(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["MlbLinker"] = factory();
	else
		root["MlbLinker"] = factory();
})(this, function() {

'use strict';

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/******/return (function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/var installedModules = {};
    /******/
    /******/ // The require function
    /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
            /******/return installedModules[moduleId].exports;
            /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
            /******/i: moduleId,
            /******/l: false,
            /******/exports: {}
            /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/__webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/__webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/__webpack_require__.i = function (value) {
        return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
            /******/Object.defineProperty(exports, name, {
                /******/configurable: false,
                /******/enumerable: true,
                /******/get: getter
                /******/ });
            /******/
        }
        /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
            return module['default'];
        } :
        /******/function getModuleExports() {
            return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/__webpack_require__.p = "";
    /******/
    /******/ // Load entry module and return exports
    /******/return __webpack_require__(__webpack_require__.s = 0);
    /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    /**
     * Static methods which validate values passed to functions (or for other validation uses).  Each throws an Error if
     * the passed value(s) is not valid; exits silently if valid.
     * @private
     */

    var BamArgValidator$1 = function () {
        function BamArgValidator$1() {
            _classCallCheck(this, BamArgValidator$1);
        }

        _createClass(BamArgValidator$1, null, [{
            key: 'validateArgs',


            /**
             * Validates the args passed to a function, throws an error if invalid values found
             * @param {object} passedArgs the "arguments" property of the calling function
             * @param {array} argNamesArr Array of function-param names (used in error-messaging)
             * @param {array} expectedTypesArr array of types (first el for first arg, second el for second arg, etc.).  More than one
             *   type is supported; separate supported types with a pipe.  For the purposes of this validation, the following
             *   are valid types: the standard types ("undefined", "object", "boolean", "number", "string", "symbol", and
             *   "function"), plus "null" and "array".  So for example, if a string or null is accepted for a given arg, the
             *   type would be "string|null"
             * @param {array} requiredBooleansArr An array of booleans; array must be same length as `expectedTypesArr`. Els should be
             *   true for required values, false otherwise; e.g., this array requires the first two of a possible four args:
             *   [true, true, false, false].  For the purposes of this method, an arg has been passed if it is not undefined.
             * @throws Error if invalid or missing args found
             */
            value: function validateArgs(passedArgs, argNamesArr, expectedTypesArr, requiredBooleansArr) {
                if (argNamesArr.length !== expectedTypesArr.length) {
                    throw new Error('expectedTypesArr, and argNamesArr must be the same length');
                }

                if (passedArgs.length > argNamesArr.length) {
                    throw new Error('this function takes ' + argNamesArr.length + ' args, but you passed ' + passedArgs.length + '.');
                }

                var required = void 0;
                var argVal = void 0;
                var allowedTypes = void 0;
                var validTypeFound = void 0;
                var argName = void 0;
                for (var i = 0; i < expectedTypesArr.length; ++i) {
                    argName = argNamesArr[i];
                    argVal = i >= passedArgs.length ? undefined : passedArgs[i];
                    required = requiredBooleansArr[i];
                    if (required && argVal === undefined) {
                        throw new Error('The "' + argName + '" param is required.');
                    }
                    allowedTypes = expectedTypesArr[i].split('|');
                    validTypeFound = false;
                    for (var _i = 0; _i < allowedTypes.length; ++_i) {
                        var allowedType = allowedTypes[_i];
                        if (argVal === undefined && !required || allowedType === 'array' && Array.isArray(argVal) || allowedType === 'null' && argVal === null || (typeof argVal === 'undefined' ? 'undefined' : _typeof(argVal)) === allowedType) {
                            validTypeFound = true;
                            break;
                        }
                    }
                    if (!validTypeFound) {
                        throw new Error('The "' + argName + '" param is an unsupported type; supported type(s): ' + expectedTypesArr[i].replace(/\|/g, ', '));
                    }
                }
            }

            /**
             * Throws an error if person is not a valid statsapi person node
             * @param person
             * @throws Error if invalid person node
             */

        }, {
            key: 'validateStatsapiPerson',
            value: function validateStatsapiPerson(person) {
                if ((typeof person === 'undefined' ? 'undefined' : _typeof(person)) !== 'object' || person.id === undefined || person.fullName === undefined) {
                    throw new Error('person must be a valid statsapi person node, as returned by various Sports Data APIs.');
                }
            }

            /**
             * Throws an error if team is not a valid statsapi team node
             * @param team
             * @throws Error if invalid team node
             */

        }, {
            key: 'validateStatsapiTeam',
            value: function validateStatsapiTeam(team) {
                if ((typeof team === 'undefined' ? 'undefined' : _typeof(team)) !== 'object' || !BamArgValidator$1._hasAllProps(team, ['id', 'name', 'teamName', 'shortName'])) {
                    throw new Error('team must be a valid statsapi team node, as returned by the Teams API.');
                }
            }

            /**
             * Throws an error if game is not a valid statsapi game node
             * @param game
             * @throws Error if invalid game node
             */

        }, {
            key: 'validateStatsapiGame',
            value: function validateStatsapiGame(game) {
                if ((typeof game === 'undefined' ? 'undefined' : _typeof(game)) !== 'object' || !BamArgValidator$1._hasAllProps(game, ['gamePk', 'gameType', 'gameDate', 'status', 'teams'])) {
                    throw new Error('game must be a valid statsapi game node, as returned by the Schedule API.');
                }
            }

            /**
             * Throws an error if game is not a valid statsapi event node
             * @param nonGameEvent
             * @throws Error if invalid event node
             */

        }, {
            key: 'validateStatsapiNonGameEvent',
            value: function validateStatsapiNonGameEvent(nonGameEvent) {
                if ((typeof nonGameEvent === 'undefined' ? 'undefined' : _typeof(nonGameEvent)) !== 'object' || !BamArgValidator$1._hasAllProps(nonGameEvent, ['id', 'eventType', 'eventDate', 'venue', 'teams'])) {
                    throw new Error('non game event must be a valid statsapi event node, as returned by the Schedule API.');
                }
            }

            /**
             * Throws an error if s is not a value of type number, or a string which can be converted to a number
             * @param s
             * @throws Error if s isn't a number
             */

        }, {
            key: 'validateNumber',
            value: function validateNumber(s) {
                if (typeof s === 'number') {
                    return;
                }
                if (typeof s === 'string' && !isNaN('' + s)) {
                    return;
                }
                throw new Error('not convertible to a numeric value: ' + s);
            }

            /**
             * Passed a value (typically of a function param), throws an error if that value is not in an array of accepted
             * values.
             * @param {*} val The value we're evaluating for validity
             * @param {array} allowedVals Allowed values
             * @throws Error if the value is not valid
             */

        }, {
            key: 'validateAllowed',
            value: function validateAllowed(val, allowedVals) {
                var allowed = Array.isArray(allowedVals) ? allowedVals : [allowedVals];
                if (allowed.indexOf(val) === -1) {
                    throw new Error('' + val + ' is not valid; accepted values are: ' + allowed);
                }
            }

            /**
             * Returns false if obj does not have all the properties in the required-props array, true if valid
             * @param obj An object
             * @param requiredPropsArr And array of strings; each el is the name of a property which the object must have
             * @private
             */

        }, {
            key: '_hasAllProps',
            value: function _hasAllProps(obj, requiredPropsArr) {
                for (var i = 0; i < requiredPropsArr.length; ++i) {
                    var prop = requiredPropsArr[i];
                    if (obj[prop] === undefined) {
                        return false;
                    }
                }
                return true;
            }
        }]);

        return BamArgValidator$1;
    }();

    /**
     * "Private" static functions used by BamTeamData and subclasses.  Other consumers should not call these methods.
     * Methods in this class which should be exposed publicly should be called from BamTeamData (as
     * getTeamArrayFromReqOrWindow() is).
     */


    var Helpers$1 = function () {
        function Helpers$1() {
            _classCallCheck(this, Helpers$1);
        }

        _createClass(Helpers$1, null, [{
            key: 'extendTeams',


            /**
             * Enhance teams array in various ways which are generic enough to be handled in the BamTeamData base class.
             * @param teams
             * @param addSlugFn
             */
            value: function extendTeams(teams, addSlugFn) {
                if (addSlugFn) {
                    var team = void 0;
                    for (var i = 0, ln = teams.length; i < ln; i++) {
                        team = teams[i];
                        addSlugFn(team);
                    }
                }
            }

            /**
             * Static method which, passed either a BANE-controller req or a BANE browser window, returns an array of teams
             * in statsapi format (see e.g. http://qa-statsapi.mlb.com/api/v1/teams/?sportId=1).  Returns null if a team array
             * could not be found.
             * @param ctx A BANE controller request or browser window
             * @param clientArrAsDotNotatedStr e.g. "team_info" if arr is window.team_info
             * @param serverArrAsDotNotatedStr e.g. "path.to.teamArr" if arr is req.path.to.teamArr
             * @return {Array} A copy of the array found in ctx, or null
             */

        }, {
            key: 'getTeamArrayFromReqOrWindow',
            value: function getTeamArrayFromReqOrWindow(ctx, clientArrAsDotNotatedStr, serverArrAsDotNotatedStr) {
                if (!clientArrAsDotNotatedStr || !serverArrAsDotNotatedStr) {
                    throw new Error('clientArrAsDotNotatedStr and serverArrAsDotNotatedStr are required.');
                }
                var teams = null;

                if (ctx.navigator) {
                    // ctx is a browser window
                    teams = Helpers$1._getObjFromDotNotatedStr(ctx, clientArrAsDotNotatedStr); // ctx.team_info;
                } else if (ctx.configFinder) {
                    // ctx is a BANE controller
                    try {
                        teams = Helpers$1._getObjFromDotNotatedStr(ctx, serverArrAsDotNotatedStr); // ctx.res.locals.teamInfo.teams, e.g. (for NHL)
                    } catch (e) {}
                }

                if (!teams) {
                    return null;
                }

                return Helpers$1.cloneDeep(teams);
            }

            /**
             * Passed an object and e.g. "some.path.to.an.object" as dotNotatedStr, returns obj.some.path.to.an.object
             * @param obj
             * @param dotNotatedStr
             * @returns {object}
             * @private
             */

        }, {
            key: '_getObjFromDotNotatedStr',
            value: function _getObjFromDotNotatedStr(obj, dotNotatedStr) {
                var els = dotNotatedStr.split('.');
                var currentObj = obj;
                var el = void 0;
                for (var i = 0, ln = els.length; i < ln; i++) {
                    el = els[i];
                    currentObj = currentObj[el];
                }
                return currentObj;
            }

            /**
             * Expose cloneDeep()
             * @param arg
             */

        }, {
            key: 'cloneDeep',
            value: function cloneDeep(arg) {
                return cloneDeep$3(arg);
            }

            /**
             * Validates options passed to the BamTeamData constructor, throws an error if invalid.
             * @param candidateOptions The options object passed to the constructor
             * @param supportedOptionSpecs SUPPORTED_OPTION_SPECS in BamTeamData
             */

        }, {
            key: 'validateOptions',
            value: function validateOptions(candidateOptions, supportedOptionSpecs) {
                // Unspecified options and passing null are both allowed:
                if (candidateOptions !== undefined && candidateOptions !== null) {
                    var errMsg = null;

                    if ((typeof candidateOptions === 'undefined' ? 'undefined' : _typeof(candidateOptions)) !== 'object' || Array.isArray(candidateOptions)) {
                        errMsg = 'is not an object.';
                    }
                    if (!errMsg) {
                        var _optionKeys = Object.keys(candidateOptions);
                        var optionSpec = void 0;
                        var optionValue = void 0;
                        var optionValueType = void 0;
                        var optionKey = void 0;
                        for (var i = 0, ln = _optionKeys.length; i < ln; i++) {
                            optionKey = _optionKeys[i];
                            optionSpec = supportedOptionSpecs[optionKey];
                            if (optionSpec === undefined) {
                                errMsg = 'contains unsupported option: ' + optionKey;
                                break;
                            }
                            optionValue = candidateOptions[optionKey];
                            optionValueType = Array.isArray(optionValue) ? 'array' : typeof optionValue === 'undefined' ? 'undefined' : _typeof(optionValue);
                            if (optionValue !== null) {
                                if (optionValueType !== optionSpec.expectedType) {
                                    errMsg = 'contains option with unexpected value type for "' + optionKey + '" (expected: ' + optionSpec.expectedType + '; found: ' + optionValueType + ')';
                                    break;
                                }
                            }
                        }
                    }

                    if (errMsg) {
                        throw new Error('The options arg you passed ' + errMsg);
                    }
                }
            }

            /**
             * Methods should call this if the base class doesn't implement the method, relying on subclasses to do so.
             * @param methodName The name of the unimplemented method, for the Error message
             * @throws Error when called.
             */

        }, {
            key: 'throwNotImplementedError',
            value: function throwNotImplementedError(methodName) {
                throw new Error(methodName + '() is not implemented in the BamTeamData, and the subclass has not provided' + 'an implementation either.');
            }

            /**
             * Validates the activeTeamsArr and inactiveTeamsArr args passed to the BamTeamData constructor.
             * @param candidateArr The array passed to the constructor
             * @param argName "activeTeamsArr" or "inactiveTeamsArr"
             * @param inactivesAllowedInActiveArr True if inactive teams are allowed in the active-teams array (e.g., since
             *  the NHL Vegas team has never played a game, it's inactive (which makes it different from typical inactive
             *  teams, which are inactive because they are historic).
             * @param activeTeams Boolean; true if these are active teams, false if inactive
             */

        }, {
            key: 'validateStatsapiTeamsArr',
            value: function validateStatsapiTeamsArr(candidateArr, argName, inactivesAllowedInActiveArr, activeTeams) {
                var errMsg = null;
                if (!Array.isArray(candidateArr)) {
                    errMsg = 'is not an array';
                }
                if (!errMsg && activeTeams && candidateArr.length === 0) {
                    errMsg = 'contains no elements';
                }
                if (!errMsg && candidateArr.length > 0) {
                    try {
                        // Don't let it throw if invalid; catch and give user a more meaningful error message:
                        BamArgValidator$1.validateStatsapiTeam(candidateArr[0]);
                    } catch (e) {
                        errMsg = 'is an array but its elements are not in statsapi-team format.';
                    }
                }
                if (!errMsg) {
                    var team = void 0;
                    for (var i = 0, ln = candidateArr.length; i < ln; i++) {
                        team = candidateArr[i];
                        if ((!inactivesAllowedInActiveArr || !activeTeams) && team.active !== activeTeams) {
                            errMsg = 'contains ' + (activeTeams ? 'in' : '') + 'active teams.';
                            break;
                        }
                    }
                }

                if (errMsg) {
                    throw new Error(argName + ' ' + errMsg);
                }
            }
        }]);

        return Helpers$1;
    }();

    /**
     * Returns a deep copy of any value. This function calls itself recursively when the passed value is not an object or
     * an array.  Functions are not cloned; they are returned by reference.
     * @param {*} val
     * @return {*}
     */


    function cloneDeep$3(val) {
        var valType = typeof val === 'undefined' ? 'undefined' : _typeof(val);

        // PRIMITIVES:
        if (val === null || ['undefined', 'boolean', 'number', 'string', 'symbol'].indexOf(valType) > -1) {
            // just return the literal value (note: typeof null is "object"):
            return val;
        }

        // FUNCTION:
        if (valType === 'function') {
            return val; // return as if a primitive; sometime we can actually figure out how to clone functions
        }

        // ARRAY:
        if (Array.isArray(val)) {
            // Type is "object" but this is an array
            var arr = [];
            var el = void 0;
            for (var i = 0, ln = val.length; i < ln; i++) {
                el = val[i];
                arr.push(cloneDeep$3(el));
            }
            return arr;
        }

        // OBJECT:
        var obj = {};
        var keys = Object.keys(val);
        var key = void 0;
        for (var _i2 = 0, _ln = keys.length; _i2 < _ln; _i2++) {
            key = keys[_i2];
            obj[key] = cloneDeep$3(val[key]);
        }
        return obj;
    }

    var cloneDeep$2 = Helpers$1.cloneDeep;

    var SUPPORTED_OPTION_SPECS = {
        // If true, active=false teams are allowed in activeTeamsArr (the case for NHL re Vegas in Q1 2017)
        inactivesAllowedInActiveArr: {
            expectedType: 'boolean',
            defaultValue: false
        },
        // If true, remove inactive teams from activeTeamsArr (the case for NHL re Vegas in Q1 2017)
        removeInactivesFromActiveArr: {
            expectedType: 'boolean',
            defaultValue: false
        },
        // A function which, passed a statsapi team, derives and sets its 'slug' property (no-op if data has slugs)
        addSlugToActiveTeamsFn: {
            expectedType: 'function',
            defaultValue: function defaultValue(team) {
                team.slug = team.franchise.teamName.toLowerCase().trim().replace(/[^a-z]/g, '');
            }
        },
        // Like addSlugToActiveTeamsFn but for inactives
        addSlugToInactiveTeamsFn: {
            expectedType: 'function',
            defaultValue: null
        }
    };

    var defaultOptions = {};
    var optionKeys = Object.keys(SUPPORTED_OPTION_SPECS);
    var key = void 0;
    for (var i = 0, ln = optionKeys.length; i < ln; i++) {
        key = optionKeys[i];
        defaultOptions[key] = SUPPORTED_OPTION_SPECS[key].defaultValue;
    }

    /**
     * Property-agnostic base class for property-specific team-data-normalizer classes such as MlbTeamData which operate
     * on data from the Sports Data API ("statsapi").
     *
     * _Nothing_ property-specific belongs in this base class.
     */

    var BamTeamData$1 = function () {

        /**
         * @param {Array} activeTeamsArr A team array in this format: http://qa-statsapi.mlb.com/api/v1/teams/?sportId=1
         * @param {Array} inactiveTeamsArr Optional depending on consumer: A team array in the format above
         * @param {object} options Options as follows (all are optional; defaults noted below):<ul>
         *  <li><i>inactivesAllowedInActiveArr:</i> If true, teams in <code>activeTeamsArr</code> whose
         *  <code>active</code> property is
         *  false are permitted (as for NHL in Jan 2017, when activeTeams contains an inactive (because it's a "future
         *  team") team, the Vegas team. If false and an inactive team is found, the constructor will throw an error.
         *  Default: false.</li>
         *  <li><i>removeInactivesFromActiveArr:</i> If true (and if the "inactivesAllowedInActiveArr"
         *  option is true), inactive teams (such as the Vegas team in the previous item) will be removed. Default:
         *  false.</li>
         *  <li><i>addSlugToActiveTeamsFn:</i> The function used to derive the team's slug from its existing properties.
         *  Pass null to signal no-op. Default: a function which returns a slug based on the team's franchise
         *  name (which is language-agnostic, the preferred behavior for most properties).</li>
         *  <li><i>addSlugToInactiveTeamsFn:</i> See previous item for description. Default: null (i.e., no-op).</li>
         * </ul>
         * @constructor
         */
        function BamTeamData$1(activeTeamsArr, inactiveTeamsArr, options) {
            _classCallCheck(this, BamTeamData$1);

            Helpers$1.validateOptions(options, SUPPORTED_OPTION_SPECS); // throw error if options not valid
            this._options = _extends(cloneDeep$2(defaultOptions), options || {}); // now we have default vals for missing options
            Helpers$1.validateStatsapiTeamsArr(activeTeamsArr, 'activeTeamsArr', this._options.inactivesAllowedInActiveArr, true);
            if (inactiveTeamsArr) {
                Helpers$1.validateStatsapiTeamsArr(inactiveTeamsArr, 'inactiveTeamsArr', false, false);
            }

            if (!this._options.removeInactivesFromActiveArr) {
                this._activeTeams = cloneDeep$2(activeTeamsArr);
            } else {
                this._activeTeams = activeTeamsArr.filter(function (team) {
                    return team.active === true;
                });
            }

            this._inactiveTeams = cloneDeep$2(inactiveTeamsArr || []);

            // Following two operations will have no effect if the addSlug fn is no-op (or falsy):
            Helpers$1.extendTeams(this._activeTeams, this._options.addSlugToActiveTeamsFn);
            Helpers$1.extendTeams(this._inactiveTeams, this._options.addSlugToInactiveTeamsFn);

            this._teamIdsToTeams = {};
            this._activeTeamSlugsToTeams = {};

            this._allTeams = this._activeTeams.concat(this._inactiveTeams);
            var team = void 0;
            for (var _i3 = 0, _ln2 = this._allTeams.length; _i3 < _ln2; _i3++) {
                team = this._allTeams[_i3];
                this._teamIdsToTeams[team.id] = team;
                if (team.active) {
                    this._activeTeamSlugsToTeams[team.slug] = team;
                }
            }
        }

        /**
         * Returns active teams.
         * @return {Array} An array of active teams.
         */


        _createClass(BamTeamData$1, [{
            key: 'getActiveTeams',
            value: function getActiveTeams() {
                return this._activeTeams;
            }

            /**
             * Returns inactive teams.
             * @return {Array} An array of inactive teams ([] if there are none; never null/undefined).
             */

        }, {
            key: 'getInactiveTeams',
            value: function getInactiveTeams() {
                return this._inactiveTeams;
            }

            /**
             * Returns the slug for the team (e.g. "devils"), or null if !team or !team.slug.  Applies to active and inactive
             * teams.
             * @param {string | number} teamId Numeric team ID, as a string or number
             * @return {string}
             */

        }, {
            key: 'getTeamSlug',
            value: function getTeamSlug(teamId) {
                var team = this._teamIdsToTeams[parseInt(teamId)];
                if (!team || !team.slug) {
                    return null;
                }
                return team.slug;
            }

            /**
             *
             * @param teamId
             * @throws Error if called; subclasses may optionally implement this method
             */

        }, {
            key: 'getTeamColors',
            value: function getTeamColors(teamId) {
                Helpers$1.throwNotImplementedError('getTeamColors');
            }

            /**
             * Returns the statsapi team with the specified teamId, if it exists. Team may be active or inactive.
             * @param teamId
             * @return {object}
             */

        }, {
            key: 'getTeam',
            value: function getTeam(teamId) {
                return this._teamIdsToTeams[teamId];
            }

            /**
             * Returns the team's public-facing abbreviation (e.g. for MLB, LAA, not ANA).
             * @param {string | number} teamId Numeric ID as number or string
             * @return {object} The team, or null if team not found
             */

        }, {
            key: 'getTeamAbbrev',
            value: function getTeamAbbrev(teamId) {
                return this._getTeamProperty(teamId, 'abbreviation');
            }

            /**
             * Return the team whose `key` property is `value`
             * @param {string} key
             * @param {*} value
             * @return {object} The team if found, or null
             */

        }, {
            key: 'getTeamByKeyValue',
            value: function getTeamByKeyValue(key, value) {
                return this._allTeams.find(function (el) {
                    return el[key] === value;
                }) || null;
            }

            /**
             * Returns true if the specified team exists
             * @param teamId {string | number} Numeric team ID, as a string or number
             * @return {boolean}
             */

        }, {
            key: 'isTeamExists',
            value: function isTeamExists(teamId) {
                return !!this._teamIdsToTeams[parseInt(teamId)];
            }

            /**
             * Returns true if the specified team is active.
             * @param teamId {string | number} Numeric team ID, as a string or number
             * @return {boolean}
             */

        }, {
            key: 'isTeamActive',
            value: function isTeamActive(teamId) {
                if (!this.isTeamExists(teamId)) {
                    return false;
                }
                return this._teamIdsToTeams[parseInt(teamId)].active;
            }

            /**
             * Returns the team's specified property, or undefined if the team doesn't exist or the team exists but its property
             * doesn't
             * @param {string | number} teamId Numeric ID as number or string
             * @param {string} property The property
             * @return {object} The team, or null if team not found
             * @private
             */

        }, {
            key: '_getTeamProperty',
            value: function _getTeamProperty(teamId, property) {
                var team = this._teamIdsToTeams[teamId];
                return !team ? undefined : team[property];
            }

            /**
             * Static method which, passed either a BANE-controller <code>req</code> or a BANE browser <code>window</code>,
             * returns an array of teams
             * in statsapi format (see e.g. http://qa-statsapi.mlb.com/api/v1/teams/?sportId=1).  Returns null if a team array
             * could not be found.
             * @param {object} ctx A BANE controller request or browser window
             * @param clientArrAsDotNotatedStr e.g. "team_info" if arr is window.team_info
             * @param serverArrAsDotNotatedStr e.g. "path.to.teamArr" if arr is req.path.to.teamArr
             * @return {Array} A copy of the array found in ctx, or null
             */

        }], [{
            key: 'getTeamArrayFromReqOrWindow',
            value: function getTeamArrayFromReqOrWindow(ctx, clientArrAsDotNotatedStr, serverArrAsDotNotatedStr) {
                return Helpers$1.getTeamArrayFromReqOrWindow(ctx, clientArrAsDotNotatedStr, serverArrAsDotNotatedStr);
            }

            /**
             * Return the _Helpers class; for use by subclasses
             * @return {_Helpers}
             */

        }, {
            key: 'getHelpers',
            value: function getHelpers() {
                return Helpers$1;
            }
        }]);

        return BamTeamData$1;
    }();

    // For building urls like baltimore.orioles.mlb.com and m.orioles.mlb.com:


    var rawUrlSegments = {/* e.g. bal: ['baltimore', 'orioles'] */};

    // Tricodes (statsapi fileCodes) to [statsapi teamCode, statsapi abbreviation]
    var fileCodesToCodes = {/* e.g. sd: ['sdn', 'sd'] */};

    var BASE_JSP_LEAGUE_URL = 'http://mlb.mlb.com';
    var BASE_V2_LEAGUE_URL = 'http://m.mlb.com';

    var initted = false;

    /**
     * @private
     */

    var LegacyData = function () {
        function LegacyData() {
            _classCallCheck(this, LegacyData);
        }

        _createClass(LegacyData, null, [{
            key: 'init',


            /**
             * Inits the LegacyData object; populates its mappings (rawUrlSegments and fileCodesToCodes)
             * @param activeTeamsArr
             */
            value: function init(activeTeamsArr) {
                if (!initted) {
                    initted = true;
                }
                var teamLoc;
                var teamName;
                var team = void 0;
                for (var _i4 = 0, _ln3 = activeTeamsArr.length; _i4 < _ln3; _i4++) {
                    team = activeTeamsArr[_i4];
                    // This is ugly: we don't have anything in the data that will give us the team's location, so we can
                    // do, for example, newyork.yankees.  The "locationName" for NYY is "Bronx", for example.  The "shortName"
                    // works except for cities that have two teams (thus NYY's shortName is "NY Yankees").  Parsing "name" (e.g.
                    // "New York Yankees") doesn't work because we don't know which space char to split on (plus that wouldn't
                    // be non-English-friendly).  So, for now, until we have a field that gives us what we need, we'll go with
                    // "locationName" and override in the cases where that's necessary:
                    var locationOverrides = {
                        140: 'Texas',
                        142: 'Minnesota',
                        147: 'New York', // Yankees; Mets are fine
                        108: 'Los Angeles', // Angels; Dodgers are fine
                        109: 'Arizona',
                        115: 'Colorado'
                    };
                    teamLoc = locationOverrides[team.id] || team.locationName;

                    // More ugliness; this is just for legacy stuff, plus the data just doesn't help here:
                    teamName = team.teamName === 'D-backs' ? 'Diamondbacks' : team.teamName;

                    rawUrlSegments[team.fileCode] = [LegacyData._getLegacyHostnameSlug(teamLoc), LegacyData._getLegacyHostnameSlug(teamName)];
                    fileCodesToCodes[team.fileCode] = [team.teamCode, team.abbreviation.toLowerCase()];
                }
            }

            /**
             * Returns a base URL for the specified team in one of two formats: http://newyork.yankees.mlb.com (if jsp=true),
             * http://m.yankees.mlb.com (if jsp=false, i.e. if it's a v2 URL)
             * @param tricode Technically, the team's statsapi fileCode (ana not laa; la not lad; etc.)
             * @param jsp True for JSP site, false for v2 site
             * @return {string} a URL in one of two formats
             * @private
             */

        }, {
            key: '_getBaseUrlFromTricode',
            value: function _getBaseUrlFromTricode(tricode, jsp) {
                LegacyData.inittedCheck('_getBaseUrlFromTricode');
                var code = (tricode || '').toLowerCase();
                if (!code || tricode === 'mlb') {
                    return jsp ? BASE_JSP_LEAGUE_URL : BASE_V2_LEAGUE_URL;
                }

                var entry = rawUrlSegments[tricode];
                if (!entry) {
                    throw new Error('No team found for tricode ' + code);
                }
                return 'http://' + (jsp ? entry[0] : 'm') + '.' + entry[1] + '.mlb.com';
            }

            /**
             * Processes calls to _getTeamCodeFromTricode() and _getAbbreviationFromTricode()
             * @param tricode Technically, the team's statsapi fileCode (ana not LAA; la not LAD; etc.)
             * @param {'teamCode' | 'abbreviation'} codeType
             * @return a teamCode or abbreviation, or null if unrecognized team
             * @private
             */

        }, {
            key: '_getCodeFromTricode',
            value: function _getCodeFromTricode(tricode, codeType) {
                LegacyData.inittedCheck('_getCodeFromTricode');
                if (rawUrlSegments[tricode] === undefined) {
                    return null;
                }

                // We're here, so the team exists.  It may or may not be in the poorly named fileCodesToCodes map; teams
                // whose tricodes (statsapi fileCodes) are the same as both their teamCodes and abbreviations are not in that
                // map; we just return the tricode in those cases (uppercased if request is for an abbreviation).

                var code = void 0;
                if (fileCodesToCodes[tricode] === undefined) {
                    code = tricode;
                } else {
                    var indices = {
                        teamCode: 0,
                        abbreviation: 1
                    };
                    code = fileCodesToCodes[tricode][indices[codeType]];
                }

                return codeType === 'abbreviation' ? code.toUpperCase() : code;
            }
        }, {
            key: '_getLegacyHostnameSlug',
            value: function _getLegacyHostnameSlug(str) {
                LegacyData.inittedCheck('_getLegacyHostnameSlug');
                var slug = str.toLowerCase().trim().replace(/[^a-z]/g, '');

                // special case for diamondbacks > dbacks:
                return slug === 'diamondbacks' ? 'dbacks' : slug;
            }

            /**
             * Throws an exception if LegacyData.init() hasn't been called
             * @param callerFnName
             * @private
             */

        }, {
            key: 'inittedCheck',
            value: function inittedCheck(callerFnName) {
                if (!initted) {
                    throw new Error('Cannot call LegacyData.' + callerFnName + '() until LegacyData.init() has been called.');
                }
            }
        }]);

        return LegacyData;
    }();

    var cloneDeep$1 = BamTeamData$1.getHelpers().cloneDeep;

    var CLIENT_ARR_DOT_NOTATION = 'team_info'; // teams arr found at window.team_info
    var SERVER_ARR_DOT_NOTATION = 'res.locals.globalData.teamInfo.teams'; // teams arr found at req.res.locals.globalData.teamInfo.teams

    /**
     *
     * @extends BamTeamData
     */

    var MlbTeamData$1 = function (_BamTeamData$) {
        _inherits(MlbTeamData$1, _BamTeamData$);

        /**
         * This class can be instantiated with a null or undefined windowOrReq, in which case the constructor assumes
         * that we are in a browser and our windowOrReq is the browser window object.  Thus, the following calls to this
         * constructor all result in the browser window object (not the controller req object) being used to initialize:
         *
         * - new MlbTeamData();
         * - new MlbTeamData(null, anArrayOfInactiveTeams);
         * - new MlbTeamData(window);
         *
         * @param windowOrReq A `window` or a BANE-controller `req`; optional (see above)
         * @param inactiveTeamsArr An array of inactive teams, if any, in Statsapi format
         * @param options Options to be passed through to the MlbTeamData constructor (this class's super()).
         */
        function MlbTeamData$1(windowOrReq, inactiveTeamsArr) {
            _classCallCheck(this, MlbTeamData$1);

            var optionOverrides = {
                // Override default slug-deriving behavior because (as yet) statsapi doesn't return a franchise for
                // MLB teams:
                addSlugToActiveTeamsFn: function addSlugToActiveTeamsFn(team) {
                    team.slug = team.teamName.toLowerCase().trim().replace(/[^a-z]/g, '');
                },
                // We're using NHL data with MLB code; causes issue because the Vegas team is inactive, as they've never
                // played a game, so, for now:
                inactivesAllowedInActiveArr: true,
                removeInactivesFromActiveArr: true
            };
            var ctx = windowOrReq;
            if (!ctx) {
                if (!!window) {
                    ctx = window;
                } else {
                    throw new Error('windowOrReq was null or undefined, but no window object was found.');
                }
            }

            var activeTeamsArr = BamTeamData$1.getTeamArrayFromReqOrWindow(ctx, CLIENT_ARR_DOT_NOTATION, SERVER_ARR_DOT_NOTATION);

            LegacyData.init(activeTeamsArr);
            return _possibleConstructorReturn(this, (MlbTeamData$1.__proto__ || Object.getPrototypeOf(MlbTeamData$1)).call(this, activeTeamsArr, inactiveTeamsArr, optionOverrides));
        }

        /**
         * Passed a team ID, returns its tricode (its c_id, or more explicitly, its statsapi `fileCode`).  Note that this
         * is _not_ its `abbreviation` - e.g., the value returned for the Angels is 'ana', not 'laa'.
         * @param teamId
         * @return {string} The team's tricode, or 'mlb' if 0 is passed, or null otherwise
         */


        _createClass(MlbTeamData$1, [{
            key: 'getTeamTricodeFromId',
            value: function getTeamTricodeFromId(teamId) {
                if (teamId === 0) {
                    return 'mlb';
                }
                var team = this._teamIdsToTeams[teamId];
                return team ? team.fileCode : null;
            }

            /**
             * Get a base production URL for the JSP ("wired") site, e.g. http://newyork.yankees.mlb.com or http://mlb.mlb.com
             * @param teamIdOrTricode Pass 0 or 'mlb' for the league site
             * @return {string} A JSP-site URL, never ending with a forward-slash, or null if unrecognized id/tricode
             */

        }, {
            key: 'getBaseJspUrl',
            value: function getBaseJspUrl(teamIdOrTricode) {
                return this._getBaseLegacyUrl(teamIdOrTricode, true);
            }

            /**
             * Get a base production URL for the V2 ("responsive") site, e.g. http://m.yankees.mlb.com or http://m.mlb.com
             * @param teamIdOrTricode Pass 0 or 'mlb' for the league site
             * @return {string} A V2-site URL, never ending with a forward-slash, or null if unrecognized id/tricode
             */

        }, {
            key: 'getBaseV2Url',
            value: function getBaseV2Url(teamIdOrTricode) {
                return this._getBaseLegacyUrl(teamIdOrTricode, false);
            }

            /**
             * Called by getBaseJspUrl() and getBaseV2Url()
             * @param teamIdOrTricode 0 or 'mlb' means league site
             * @param jsp True for JSP site, false for V2 site
             * @return {string} The URL, or null if unrecognized
             * @private
             */

        }, {
            key: '_getBaseLegacyUrl',
            value: function _getBaseLegacyUrl(teamIdOrTricode, jsp) {
                var id = parseInt(teamIdOrTricode);
                var tricode = void 0;
                if (!isNaN(id)) {
                    if (id === 0) {
                        tricode = 'mlb';
                    } else {
                        var _team = this.getTeam(id);
                        if (!_team) {
                            // we don't recognize the tricode or id; not the end of the world - we'll use the league URL
                            // instead:
                            tricode = 'mlb';
                        } else {
                            tricode = _team.fileCode;
                        }
                    }
                } else {
                    tricode = teamIdOrTricode;
                }
                return LegacyData._getBaseUrlFromTricode(tricode, jsp) || null;
            }

            /**
             * Passed a tricode, return a teamCode (e.g. nym - nyn)
             * @param tricode Technically, the team's statsapi fileCode (ana not LAA; la not LAD; etc.)
             * @return {string} The team's statsapi teamCode (e.g. nyn - yes nyn, not nym - for Mets), or null if unrecognized
             * @private
             */

        }], [{
            key: 'getTeamCodeFromTricode',
            value: function getTeamCodeFromTricode(tricode) {
                return LegacyData._getCodeFromTricode(tricode, 'teamCode');
            }

            /**
             * passed a tricode, return an abbreviation (e.g. la - LAD)
             * @param tricode Technically, the team's statsapi fileCode (ana not LAA; la not LAD; etc.), or null if unrecognized
             * @return {string} The team's statsapi abbreviation (e.g. NYM for Mets)
             * @private
             */

        }, {
            key: 'getAbbreviationFromTricode',
            value: function getAbbreviationFromTricode(tricode) {
                return LegacyData._getCodeFromTricode(tricode, 'abbreviation');
            }
        }]);

        return MlbTeamData$1;
    }(BamTeamData$1);

    var cloneDeep$5 = BamTeamData$1.getHelpers().cloneDeep;

    /**
     * "Private" static functions used by BamLinker and subclasses.  Other consumers should not call these
     * methods.
     * @private
     */

    var Helpers$3 = function () {
        function Helpers$3() {
            _classCallCheck(this, Helpers$3);
        }

        _createClass(Helpers$3, null, [{
            key: 'validateOptions',


            /**
             * Validates options passed to the BamLinker constructor, throws an error if invalid.
             * @param options The options object passed to the constructor
             * @param supportedOptionSpecs SUPPORTED_OPTION_SPECS
             * @throws Error if options are not valid
             */
            value: function validateOptions(candidateOptions, supportedOptionSpecs) {
                var errMsg = null;
                var options = !candidateOptions ? {} : candidateOptions;

                // Options must be an object:
                if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' || Array.isArray(options)) {
                    errMsg = 'is not an object.';
                }

                // Each user-specified option must conform to its spec:
                if (!errMsg) {
                    var _optionKeys2 = Object.keys(options);
                    var optionSpec = void 0;
                    var optionValue = void 0;
                    var optionValueType = void 0;
                    var optionKey = void 0;
                    for (var _i5 = 0, _ln4 = _optionKeys2.length; _i5 < _ln4; _i5++) {
                        optionKey = _optionKeys2[_i5];
                        optionSpec = supportedOptionSpecs[optionKey];
                        if (optionSpec === undefined) {
                            errMsg = 'contains unsupported option: ' + optionKey;
                            break;
                        }
                        optionValue = options[optionKey];
                        optionValueType = Array.isArray(optionValue) ? 'array' : typeof optionValue === 'undefined' ? 'undefined' : _typeof(optionValue);
                        if (optionValue !== null) {
                            if (optionValueType !== optionSpec.expectedType) {
                                errMsg = 'contains option with unexpected value type for "' + optionKey + '" (expected: ' + optionSpec.expectedType + '; found: ' + optionValueType + ')';
                                break;
                            }
                        }
                    }
                }

                // Required options must be present:
                var specKeys = Object.keys(supportedOptionSpecs);
                var specKey = void 0;
                for (var _i6 = 0, _ln5 = specKeys.length; _i6 < _ln5; _i6++) {
                    specKey = specKeys[_i6];
                    if (!supportedOptionSpecs[specKey].required) {
                        continue;
                    }
                    if (options[specKey] === undefined) {
                        errMsg = 'did not contain a required option: ' + specKey;
                        break;
                    }
                }

                if (errMsg) {
                    throw new Error('The options arg you passed ' + errMsg);
                }
            }

            /**
             * Return an object whose properties are option keys and values are default values for those options
             * @param supportedOptionSpecs
             * @return {{}}
             */

        }, {
            key: 'getDefaultOptions',
            value: function getDefaultOptions(supportedOptionSpecs) {
                var defaultOptions = {};
                var optionKeys = Object.keys(supportedOptionSpecs);
                var key = void 0;
                for (var _i7 = 0, _ln6 = optionKeys.length; _i7 < _ln6; _i7++) {
                    key = optionKeys[_i7];
                    defaultOptions[key] = supportedOptionSpecs[key].defaultValue;
                }
                return defaultOptions;
            }

            /**
             * Returns the value of a call to the cloneDeep method, which returns a deep copy of the passed value.
             * @param arg
             */

        }, {
            key: 'cloneDeep',
            value: function cloneDeep(arg) {
                return cloneDeep$5(arg);
            }

            /**
             * A generic method which subclass implementations may use to derive and add request-specific values to
             * subclass-constructor
             * options (langCode, teamId, deviceType, and appView).  Ideally this method will work for all BANE sites, but
             * it seems likely that there will be exceptions.
             * @param generatorConstructorOptions Options which will be passed to the BamLinker constructor from
             *   a BamLinker subclass's constructor; langCode, teamId, deviceType, and appView properties are added
             *   to this object
             * @param windowOrReq A BANE-controller `req` or a browser `window`
             * @param addDefaultsOnError If true and this method throws an error, the error will be swallowed and default values
             *   will be added to the options object.  This should only be true for BamLinker subclass constructors
             *   which are in development, and thus can't depend on being able to find values where they should be.
             */

        }, {
            key: 'addRequestSpecificOptions',
            value: function addRequestSpecificOptions(generatorConstructorOptions, windowOrReq, addDefaultsOnError) {
                try {
                    generatorConstructorOptions.windowOrReq = windowOrReq;
                    if (windowOrReq.navigator) {
                        // windowOrReq is a browser window:
                        generatorConstructorOptions.clientSide = true;
                        var metaTags = windowOrReq.document.getElementsByTagName('meta');
                        generatorConstructorOptions.appView = Helpers$3._getMetaTagContent(metaTags, 'app-view') || 'web';
                        generatorConstructorOptions.langCode = Helpers$3._getMetaTagContent(metaTags, 'locale') || 'en';
                        generatorConstructorOptions.deviceType = 'desktop'; // hard-coding for now
                        generatorConstructorOptions.teamId = parseInt(Helpers$3._getMetaTagContent(metaTags, 'team_id') || 0);
                    } else if (windowOrReq.configFinder && windowOrReq.i18n) {
                        // windowOrReq is a BANE-controller request:
                        generatorConstructorOptions.clientSide = false;
                        generatorConstructorOptions.appView = windowOrReq.configFinder.appView;
                        generatorConstructorOptions.langCode = windowOrReq.configFinder.getLocale();
                        generatorConstructorOptions.deviceType = 'desktop'; // hard-coding for now
                        generatorConstructorOptions.teamId = parseInt(windowOrReq.configFinder.clubConfig && windowOrReq.configFinder.clubConfig.team ? windowOrReq.configFinder.clubConfig.team.team_id || 0 : 0);
                    } else {
                        throw new Error('The "windowOrReq" constructor param must be either a BANE browser window or ' + 'a BANE-controller "req" obj.');
                    }
                } catch (e) {
                    if (!addDefaultsOnError) {
                        throw e;
                    }
                    console.warn('Error thrown getting constructor-option values from "' + windowOrReq + '"; swallowing ' + 'this error and adding default option values because addDefaultsOnError is true (it should only be ' + 'true in development).  Error:');
                    console.warn(e);
                    if (console.trace) {
                        console.trace();
                    }
                    generatorConstructorOptions.appView = 'web';
                    generatorConstructorOptions.langCode = 'en';
                    generatorConstructorOptions.deviceType = 'desktop';
                    generatorConstructorOptions.teamId = 0;
                }
            }

            /**
             * Returns the content (i.e., the value) of the meta tag identified by `key`
             * @param metaTagEls Typically the value returned by window.document.getElementsByTagName('meta')
             * @param key The meta tag's name, property, or http-equiv attribute value
             * @return {string} The meta tag's content (its value), or null if the tag wasn't found
             * @private
             */

        }, {
            key: '_getMetaTagContent',
            value: function _getMetaTagContent(metaTagEls, key) {
                var metaTagKeyAttrNames = ['name', 'property', 'http-equiv'];

                for (var k = 0, kln = metaTagKeyAttrNames.length; k < kln; k++) {
                    for (var i = 0, mln = metaTagEls.length; i < mln; i++) {
                        if (metaTagEls[i].getAttribute(metaTagKeyAttrNames[k]) === key) {
                            return metaTagEls[i].getAttribute('content');
                        }
                    }
                }
                // sorry, no luck:
                return null;
            }

            /**
             * Methods should call this if the base class doesn't implement the method, relying on subclasses to do so.
             * @param methodName The name of the unimplemented method, for the Error message
             * @throws Error when called.
             */

        }, {
            key: 'throwNotImplementedError',
            value: function throwNotImplementedError(methodName) {
                throw new Error(methodName + '() is not implemented in the BamLinker, and the subclass has not provided' + 'an implementation either.');
            }

            /**
             * Passed a date in format 2016-08-17T00:05:00Z, return 2016-08-16 (the date in EST)
             *
             * Implementation note: not using moment here because don't want the overhead in this base class which will often
             * be a part of basesite.  Thus, doing some Date hackery instead (note: hackery has to be browser-friendly too, not
             * only ES6).
             *
             * @param dateStr A date in format '2016-08-17T00:05:00Z' (e.g. as returned by statsapi)
             * @param gmtOffsetHours The offset, in hours; e.g. EST offset is -5
             * @param delimiter char to separate year, month, date
             * @return {string} e.g. 2016-08-16
             */

        }, {
            key: 'getYMDStrFromStatsapiDate',
            value: function getYMDStrFromStatsapiDate(dateStr, gmtOffsetHours, delimiter) {
                var date = new Date(parseInt(dateStr.substring(0, 4)), // year
                parseInt(dateStr.substring(5, 7)) - 1, // month
                parseInt(dateStr.substring(8, 10)), // day in month
                parseInt(dateStr.substring(11, 13)), // hours
                parseInt(dateStr.substring(14, 16)), // minutes
                parseInt(dateStr.substring(17, 19)), // seconds
                0 // millis
                );

                var offsetMillis = gmtOffsetHours * 1000 * 60 * 60; // likely negative, e.g. if offset is ET
                date.setTime(date.getTime() + offsetMillis);
                var month = '' + (date.getMonth() + 1);
                var dateInMonth = '' + date.getDate();
                month = month.length === 1 ? '0' + month : month;
                dateInMonth = dateInMonth.length === 1 ? '0' + dateInMonth : dateInMonth;
                return '' + date.getFullYear() + delimiter + month + delimiter + dateInMonth;
            }
        }]);

        return Helpers$3;
    }();

    /*!
     * based off lehelk.com post:
     * http://lehelk.com/2011/05/06/script-to-remove-diacritics/
     *
     * omptimized by Rodrigo di Lorenzo Lopes
     * http://jsperf.com/diacritics/12
     */

    /**
     * Passed a string, returns a string suitable for use as part of a URL (special characters such as letters with
     * accents and such are converted to their accent-free versions; apostrophes and hyphens are handled; etc.). Sample
     * ins and outs:
     * <ul>
     * <li>"Dodgers blank Padres behind Ryu's 10 K's" > "dodgers-blank-padres-behind-ryus-10-ks"</li>
     * <li>"Gausman gets rain-shortened CG win over Yanks" > "gausman-gets-rain-shortened-cg-win-over-yanks"</li>
     * <li>"Núñez con enorme potencial como 3B de Atléticos" > "nunez-con-enorme-potencial-como-3b-de-atleticos"</li>
     * </ul>
     * @param {string} str
     * @return {string}
     */


    var seoUrl$1 = function seoUrl$1(str) {

        var diactricsRemovalMap = [{ base: 'A', letters: 'A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F' }, { base: 'AA', letters: '\uA732' }, { base: 'AE', letters: '\xC6\u01FC\u01E2' }, { base: 'AO', letters: '\uA734' }, { base: 'AU', letters: '\uA736' }, { base: 'AV', letters: '\uA738\uA73A' }, { base: 'AY', letters: '\uA73C' }, { base: 'B', letters: 'B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' }, { base: 'C', letters: 'C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E' }, { base: 'D', letters: 'D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779' }, { base: 'DZ', letters: '\u01F1\u01C4' }, { base: 'Dz', letters: '\u01F2\u01C5' }, { base: 'E', letters: 'E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E' }, { base: 'F', letters: 'F\u24BB\uFF26\u1E1E\u0191\uA77B' }, { base: 'G', letters: 'G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E' }, { base: 'H', letters: 'H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D' }, { base: 'I', letters: 'I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197' }, { base: 'J', letters: 'J\u24BF\uFF2A\u0134\u0248' }, { base: 'K', letters: 'K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2' }, { base: 'L', letters: 'L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780' }, { base: 'LJ', letters: '\u01C7' }, { base: 'Lj', letters: '\u01C8' }, { base: 'M', letters: 'M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' }, { base: 'N', letters: 'N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4' }, { base: 'NJ', letters: '\u01CA' }, { base: 'Nj', letters: '\u01CB' }, { base: 'O', letters: 'O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C' }, { base: 'OI', letters: '\u01A2' }, { base: 'OO', letters: '\uA74E' }, { base: 'OU', letters: '\u0222' }, { base: 'P', letters: 'P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' }, { base: 'Q', letters: 'Q\u24C6\uFF31\uA756\uA758\u024A' }, { base: 'R', letters: 'R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782' }, { base: 'S', letters: 'S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784' }, { base: 'T', letters: 'T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786' }, { base: 'TZ', letters: '\uA728' }, { base: 'U', letters: 'U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244' }, { base: 'V', letters: 'V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' }, { base: 'VY', letters: '\uA760' }, { base: 'W', letters: 'W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' }, { base: 'X', letters: 'X\u24CD\uFF38\u1E8A\u1E8C' }, { base: 'Y', letters: 'Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE' }, { base: 'Z', letters: 'Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762' }, { base: 'a', letters: 'a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250' }, { base: 'aa', letters: '\uA733' }, { base: 'ae', letters: '\xE6\u01FD\u01E3' }, { base: 'ao', letters: '\uA735' }, { base: 'au', letters: '\uA737' }, { base: 'av', letters: '\uA739\uA73B' }, { base: 'ay', letters: '\uA73D' }, { base: 'b', letters: 'b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' }, { base: 'c', letters: 'c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184' }, { base: 'd', letters: 'd\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A' }, { base: 'dz', letters: '\u01F3\u01C6' }, { base: 'e', letters: 'e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD' }, { base: 'f', letters: 'f\u24D5\uFF46\u1E1F\u0192\uA77C' }, { base: 'g', letters: 'g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F' }, { base: 'h', letters: 'h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265' }, { base: 'hv', letters: '\u0195' }, { base: 'i', letters: 'i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131' }, { base: 'j', letters: 'j\u24D9\uFF4A\u0135\u01F0\u0249' }, { base: 'k', letters: 'k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3' }, { base: 'l', letters: 'l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747' }, { base: 'lj', letters: '\u01C9' }, { base: 'm', letters: 'm\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' }, { base: 'n', letters: 'n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5' }, { base: 'nj', letters: '\u01CC' }, { base: 'o', letters: 'o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275' }, { base: 'oi', letters: '\u01A3' }, { base: 'ou', letters: '\u0223' }, { base: 'oo', letters: '\uA74F' }, { base: 'p', letters: 'p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' }, { base: 'q', letters: 'q\u24E0\uFF51\u024B\uA757\uA759' }, { base: 'r', letters: 'r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783' }, { base: 's', letters: 's\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B' }, { base: 't', letters: 't\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787' }, { base: 'tz', letters: '\uA729' }, { base: 'u', letters: 'u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289' }, { base: 'v', letters: 'v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' }, { base: 'vy', letters: '\uA761' }, { base: 'w', letters: 'w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' }, { base: 'x', letters: 'x\u24E7\uFF58\u1E8B\u1E8D' }, { base: 'y', letters: 'y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF' }, { base: 'z', letters: 'z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763' }];

        var diacriticsMap = {};

        for (var i = 0; i < diactricsRemovalMap.length; i++) {
            var letters = diactricsRemovalMap[i].letters.split('');
            for (var j = 0; j < letters.length; j++) {
                diacriticsMap[letters[j]] = diactricsRemovalMap[i].base;
            }
        }

        function removeDiacritics(str) {
            return str.replace(/[^\u0000-\u007E]/g, function (a) {
                return diacriticsMap[a] || a;
            });
        }

        return removeDiacritics(str).toLowerCase().trim().replace(/ +/g, '-').replace(/[^\w-]+/g, '');
    };

    /**
     * Static functions which are defaults for various options passed to the BamLinker constructor. Consumers
     * are not meant to invoke any of these functions directly, but they may be useful for reference, when overriding for
     * property-specific subclasses.
     */

    var DefaultFunctions = function () {
        function DefaultFunctions() {
            _classCallCheck(this, DefaultFunctions);
        }

        _createClass(DefaultFunctions, null, [{
            key: 'getPathEl',


            /**
             * Passed a langCode, appView, or teamId, returns a path element like '/fr'.  If `identifier` and
             * `defaultIdentifier` are equal, the returned path element will be empty-string.  Values returned by this function
             * are concatenated when building URLs.  Some examples:
             * <ul>
             *   <li>Passed 'en' langCode, returns '' (since 'en' is the default)</li>
             *   <li>Passed 'fr' langCode, returns '/fr'</li>
             *   <li>Passed 'web' appView, returns '' (since 'web' is the default)</li>
             *   <li>Passed 'app' appView, returns '/app'</li>
             *   <li>Passed 0 teamId, returns '' (since 0 is the default)</li>
             *   <li>Passed 1 teamId, returns (for NHL) '/devils'</li>
             *   <li>Passed 555 teamId, throws an error, as there is no team with ID 555</li>
             * </ul>
             * @param {BamLinker} linker A BamLinker instance
             * @param {string} identifier The langCode, appView, or teamId
             * @param {string} defaultIdentifier The default langCode, appView, or teamId
             * @param {boolean} identifierIsTeamId True if `identifier` is a teamId (thus we must match it to a team and its slug), false
             *   otherwise
             * @return {string}
             */
            value: function getPathEl(linker, identifier, defaultIdentifier, identifierIsTeamId) {
                BamArgValidator$1.validateArgs(arguments, ['linker', 'identifier', 'defaultIdentifier', 'identifierIsTeamId'], ['object', 'string|number', 'string|number', 'boolean'], [true, true, true, true]);
                if (identifier === defaultIdentifier) {
                    return '';
                }
                var segment = void 0;
                if (!identifierIsTeamId) {
                    segment = identifier;
                } else {
                    segment = linker._teamData.getTeamSlug(identifier);
                    if (segment === null) {
                        throw new Error('There is no team with ID ' + identifier);
                    }
                }
                return '/' + segment;
            }

            /**
             * Builds a generic link.  This function is called by BamLinker.getLink() after that method does a small
             * amount of validation.  Returns concatenation of the following values (all of which may be empty-string except for
             * `urlSegment`, which minimally has a length of 1 ('/').  The values:
             * <ul>
             *     <li>an appView segment such as '/app' or ''</li>
             *     <li>a langCode segment such as '/fr' or ''</li>
             *     <li>a team segment such as '/rangers' or ''</li>
             *     <li>The `urlSegment` value</li>
             * </ul>
             * Thus URLs returned by this function could be as simple as '/' and as complex as
             * http://www.somehost.com/app/fr/rangers/somesection/someparam/someparam
             * @param {BamLinker} linker A BamLinker instance
             * @param {string} urlSegment The segment to append to the base URL, e.g. "/player/some-player-121212". Segments
             *   which don't
             *   start with a forward-slash get one prepended automatically.
             * @param {boolean} keepTeam If true and the current request's teamId is not zero (meaning, there's currently a
             *   team segment
             *   on the URL), that segment will be preserved for the returned URL.  If false, it won't be. The default is true.
             * @return {string}
             */

        }, {
            key: 'buildLink',
            value: function buildLink(linker, urlSegment, keepTeam) {
                BamArgValidator$1.validateArgs(arguments, ['linker', 'urlSegment', 'keepTeam'], ['object', 'string', 'boolean'], [true, true, false]);

                var url = linker._appViewPathEl + linker._langCodePathEl + (keepTeam ? linker._teamPathEl : '') + urlSegment;
                return url;
            }

            /**
             * Builds a player-page link in the format '/player/playerSlug', with no team segment preserved.  The potentially
             * redundant statsapiPerson and fullname/id fields are passed straight through to the _buildPlayerSlugFn; see
             * its API docs for details.
             * @param {BamLinker} linker A BamLinker instance
             * @param {object | null} statsapiPerson
             * @param {string} fullname
             * @param {string | number} playerId
             * @param {string | number} A team ID; whether required/used depends on property
             * @return {string} A player-page URL as returned by `buildLink()`
             */

        }, {
            key: 'buildPlayerPageLink',
            value: function buildPlayerPageLink(linker, statsapiPerson, fullname, playerId, playerTeamId) {
                BamArgValidator$1.validateArgs(arguments, ['linker', 'statsapiPerson', 'fullname', 'playerId', 'playerTeamId'], ['object', 'object|null', 'string', 'string|number', 'string|number'], [true, true, true, true, false]);
                return linker._buildLinkFn(linker, '/player/' + linker._buildPlayerSlugFn(linker, statsapiPerson, fullname, playerId), false);
            }

            /**
             * Build a player slug in the format first-last-12345678 based on either the statsapiPerson param, or the fullname
             * and id params.  Specifically, if the statsapiPerson object contains a slug value (by default in this base class,
             * otherNames.slug), we'll use that.  If not, we'll derive one from the fullname and id.  This way, we rely on
             * statsapi as the single source of truth for slugs _if they're providing that field_.  If not, we fall back on
             * deriving it ourselves.
             * @param linker A BamLinker instance
             * @param {object | null} statsapiPerson, or null if the caller doesn't have one to pass.  If the statsapiPerson
             *   doesn't have a otherNames.slug value, that's fine; fullname and playerId will be used instead.
             * @param {string} fullname
             * @param {string | number} playerId
             * @return {string} E.g. first-last-12345678
             */

        }, {
            key: 'buildPlayerSlug',
            value: function buildPlayerSlug(linker, statsapiPerson, fullname, playerId) {
                BamArgValidator$1.validateArgs(arguments, ['linker', 'statsapiPerson', 'fullname', 'playerId'], ['object', 'object|null', 'string', 'string|number'], [true, true, true, true]);
                if (statsapiPerson && statsapiPerson.otherNames && statsapiPerson.otherNames.slug) {
                    // The API had a slug value:
                    return statsapiPerson.otherNames.slug;
                }

                // The API _didn't_ have a slug value:
                return seoUrl$1(fullname + ' ' + playerId);
            }

            /**
             * Build a team homepage link; likely property-dependent - the default here is the format "/teamslug"
             * @param linker {BamLinker} A BamLinker instance
             * @param {string | number} teamId The ID of the team whose homepage to link to.
             * @return {string} A team-homepage URL as returned by `buildLink()`, or null if unrecognized active team ID.
             */

        }, {
            key: 'buildTeamHomepageLink',
            value: function buildTeamHomepageLink(linker, teamId) {
                var slug = linker._teamData.getTeamSlug(teamId);
                if (!slug) {
                    return null;
                }

                return linker._buildLinkFn(linker, '/' + slug, false);
            }

            /**
             * Build a team schedule link; likely property-dependent - the default here is the format "/schedule/teamslug"
             * @param linker {BamLinker} A BamLinker instance
             * @param {string | number} teamId The ID of the team whose schedule to link to.
             * @return {string} A team-schedule URL as returned by `buildLink()`, or null if unrecognized active team ID.
             */

        }, {
            key: 'buildTeamScheduleLink',
            value: function buildTeamScheduleLink(linker, teamId) {
                var slug = linker._teamData.getTeamSlug(teamId);

                if (!slug) {
                    return null;
                }

                return linker._buildLinkFn(linker, '/' + slug + '/schedule', false);
            }
        }]);

        return DefaultFunctions;
    }();

    var cloneDeep$4 = BamTeamData$1.getHelpers().cloneDeep;

    /*
     * See constructor JSDocs for details about each option.  Note that some required options also have a default value.
     * This is because, for example, the default value for appView, 'web', is treated differently from any other value for
     * appView (e.g., 'app').
     */
    var SUPPORTED_OPTION_SPECS$1 = {
        langCode: {
            expectedType: 'string',
            defaultValue: 'en',
            required: true
        },
        deviceType: {
            expectedType: 'string',
            required: true
        },
        appView: {
            expectedType: 'string',
            defaultValue: 'web',
            required: true
        },
        teamId: {
            expectedType: 'number',
            defaultValue: 0,
            required: true
        },
        fqSiteCorePrefixUrl: {
            expectedType: 'string',
            defaultValue: '',
            required: true
        },
        clientSide: {
            expectedType: 'boolean',
            defaultValue: true,
            required: true
        },
        windowOrReq: {
            expectedType: 'object',
            defaultValue: {},
            required: true
        },
        getLangCodePathElFn: {
            expectedType: 'function',
            defaultValue: DefaultFunctions.getPathEl,
            required: false
        },
        getAppViewPathElFn: {
            expectedType: 'function',
            defaultValue: DefaultFunctions.getPathEl,
            required: false
        },
        getTeamIdPathElFn: {
            expectedType: 'function',
            defaultValue: DefaultFunctions.getPathEl,
            required: false
        },
        buildLinkFn: {
            expectedType: 'function',
            defaultValue: DefaultFunctions.buildLink,
            required: false
        },
        buildPlayerPageLinkFn: {
            expectedType: 'function',
            defaultValue: DefaultFunctions.buildPlayerPageLink,
            required: false
        },
        buildTeamHomepageLinkFn: {
            expectedType: 'function',
            defaultValue: DefaultFunctions.buildTeamHomepageLink,
            required: false
        },
        buildPlayerSlugFn: {
            expectedType: 'function',
            defaultValue: DefaultFunctions.buildPlayerSlug,
            required: false
        },
        buildTeamScheduleLinkFn: {
            expectedType: 'function',
            defaultValue: DefaultFunctions.buildTeamScheduleLink,
            required: false
        }
    };

    var defaultOptions$1 = Helpers$3.getDefaultOptions(SUPPORTED_OPTION_SPECS$1);

    /**
     * Property-agnostic base class for property-specific linker classes such as MlbLinker which operate
     * on data from the Sports Data API ("statsapi").
     *
     * _Nothing_ property-specific belongs in this base class.
     */

    var BamLinker$1 = function () {

        /**
         *
         * @param {BamTeamData} bamTeamData An instance of [BamTeamData](https://github.mlbam.net/fed-packages/bam-team-data/blob/master/docs/index.md#bamteamdata) or subclass
         * @param {object} options Options as follows (optional unless noted otherwise):<br/><br/>
         *
         *   Note: several of the options below are functions (whose defaults are in this package's `DefaultFunctions` class).
         *   Overriding the functionality of this base class in subclasses may be accomplished by specifying different
         *   functions in the options you pass to this constructor; however, overriding specific subclass instance methods
         *   may make more sense.
         *  <ul>
         *    <li><i>langCode:</i> **Required.** The language code for the current request. Default: 'en'.</li>
         *    <li><i>appView:</i> **Required.** The app-view for the current request ('web', 'app', etc.). Handling of appViews may end
         *      up being handled mostly in subclasses; depends on whether or not various BANE sites handle them in the same
         *      way.</li>
         *    <li><i>deviceType:</i> **Required.** The type of client; valid values are 'desktop', 'tablet', and 'phone'.</li>
         *    <li><i>teamId:</i> **Required.** The team ID of the current request. Zero typically means a league site; a
         *      positive number would indicate that we're on a specific team's website.</li>
         *    <li><i>clientSide:</i> **Required.** Boolean: true if we're client-side, false if we're server-side.</li>
         *    <li><i>windowOrReq:</i> **Required.** A BANE "req" or a browser window object.</li>
         *    <li><i>getLangCodePathElFn:</i> A function which determines how to construct a path segment like '/fr' when
         *      passed the langCode of the current request, e.g. 'fr'.  This function takes four args; see the default for a
         *      sample implementation. Default: `DefaultFunctions.getPathEl`.</li>
         *    <li><i>getAppViewPathElFn:</i> Like the previous item, but for the current appView. Default: same as
         *      previous.</li>
         *    <li><i>getTeamIdPathElFn:</i> Like the previous item, but for the current teamId (if present). Default:
         *    same as previous.</li>
         *    <li><i>buildLinkFn:</i> A function which, passed a segment such as '/news/12121212', generates a URL based on
         *      the current request.  This function is used for generic links; player-page links and team-homepage links
         *      have their own functions (see next two items).  Default: `DefaultFunctions.buildLink`.</li>
         *    <li><i>buildPlayerPageLinkFn:</i> Like the previous item, but specifically for player-page links.
         *      Default: `DefaultFunctions.buildPlayerPageLink`.</li>
         *    <li><i>buildPlayerSlugFn:</i> Builds a player slug, for use in player-page links; format is
         *      property-dependent. Default: `DefaultFunctions.buildPlayerSlug`.</li>
         *    <li><i>buildTeamHomepageLinkFn:</i> Like the previous item, but specifically for team-homepage links.
         *      Default: `DefaultFunctions.buildTeamHomepageLink`.</li>
         *  </ul>
         */

        function BamLinker$1(bamTeamData, options) {
            _classCallCheck(this, BamLinker$1);

            Helpers$3.validateOptions(options, SUPPORTED_OPTION_SPECS$1); // throw error if options not valid
            var opts = _extends(cloneDeep$4(defaultOptions$1), options || {}); // now we have default vals for missing options
            this._teamData = bamTeamData;
            this._langCode = opts.langCode;
            this._deviceType = opts.deviceType;
            this._appView = opts.appView;
            this._teamId = opts.teamId;
            this._clientSide = opts.clientSide;
            this._windowOrReq = opts.windowOrReq;
            this._langCodePathEl = opts.getLangCodePathElFn(this, this._langCode, SUPPORTED_OPTION_SPECS$1.langCode.defaultValue, false);
            this._appViewPathEl = opts.getAppViewPathElFn(this, this._appView, SUPPORTED_OPTION_SPECS$1.appView.defaultValue, false);
            this._teamPathEl = opts.getTeamIdPathElFn(this, this._teamId, SUPPORTED_OPTION_SPECS$1.teamId.defaultValue, true);
            this._buildLinkFn = opts.buildLinkFn;
            this._buildPlayerPageLinkFn = opts.buildPlayerPageLinkFn;
            this._buildPlayerSlugFn = opts.buildPlayerSlugFn;
            this._buildTeamHomepageLinkFn = opts.buildTeamHomepageLinkFn;
            this._buildTeamScheduleLinkFn = opts.buildTeamScheduleLinkFn;
        }

        /**
         * Return a link, preserving language, app-view, and team (if keepTeam is true)
         * @param {string} urlSegment e.g. /schedule; should never contain app-view or lang path segments (/fr, /app, etc.).
         * Forward-slash will be prepended if not passed.
         * @param {boolean} keepTeam If true, the team-slug URL segment (if any) will be preserved. Default is true.
         * @return {string}
         */


        _createClass(BamLinker$1, [{
            key: 'getLink',
            value: function getLink(urlSegment, keepTeam) {
                BamArgValidator$1.validateArgs(arguments, ['urlSegment', 'keepTeam'], ['string', 'boolean'], [true, false]);
                var keepTeamPathElement = keepTeam === undefined ? true : keepTeam;

                var segment = '' + urlSegment;
                if (segment.charAt(0) !== '/') {
                    segment = '/' + segment;
                }
                return this._buildLinkFn(this, segment, keepTeamPathElement);
            }

            /**
             * Returns a player-page link based on a player's statsapi Person node.
             * @param {string | number} statsapiPerson A player's person node as returned by statsapi
             * @param {string | number} teamId The player's team ID.  Whether or not this param is required depends on the
             *   property.
             * @return {string} The player-page link with a slug like 'first-last-12345678'
             */

        }, {
            key: 'getPlayerPageLink',
            value: function getPlayerPageLink(statsapiPerson, teamId) {
                BamArgValidator$1.validateArgs(arguments, ['statsapiPerson', 'teamId'], ['object', 'string|number'], [true, false]);
                BamArgValidator$1.validateStatsapiPerson(statsapiPerson);
                return this._buildPlayerPageLinkFn(this, statsapiPerson, statsapiPerson.fullName, statsapiPerson.id, teamId);
            }

            /**
             * Returns a player-page link based on a player's name and ID
             * @param fullname e.g. John Smith; required
             * @param playerId Numeric player ID; required
             * @param teamId Numeric player ID; Whether or not this param is required depends on the property
             */

        }, {
            key: 'getPlayerPageLinkByNameAndId',
            value: function getPlayerPageLinkByNameAndId(fullname, playerId, teamId) {
                BamArgValidator$1.validateArgs(arguments, ['fullname', 'playerId', 'teamId'], ['string', 'string|number', 'string|number'], [true, true, false]);
                return this._buildPlayerPageLinkFn(this, null, fullname, playerId, teamId);
            }

            /**
             * Returns a player-page slug based on the statsapi Person node
             * @param statsapiPerson A person node returned by the statsapi
             * @return {string} E.g. 'john-smith-12345678'
             */

        }, {
            key: 'getPlayerSlug',
            value: function getPlayerSlug(statsapiPerson) {
                BamArgValidator$1.validateStatsapiPerson(statsapiPerson);
                return this._buildPlayerSlugFn(this, statsapiPerson, statsapiPerson.fullName, statsapiPerson.id);
            }

            /**
             * Returns a player-page slug based on player name and ID
             * @param fullname e.g. John Smith; required
             * @param playerId Numeric player ID; required;
             * @return {string} E.g. 'john-smith-12345678'
             */

        }, {
            key: 'getPlayerSlugByNameAndId',
            value: function getPlayerSlugByNameAndId(fullname, playerId) {
                BamArgValidator$1.validateArgs(arguments, ['fullname', 'playerId'], ['string', 'string|number'], [true, true]);
                return this._buildPlayerSlugFn(this, null, fullname, playerId);
            }

            /**
             * Returns a team-homepage link based on the specified team ID
             * @param {number | string} teamId Numeric team id, as a number or string
             * @return {string} The link, or null if the team is not recognized as an active team
             */

        }, {
            key: 'getTeamHomepageLinkFromTeamId',
            value: function getTeamHomepageLinkFromTeamId(teamId) {
                BamArgValidator$1.validateArgs(arguments, ['teamId'], ['string|number'], [true]);
                return this._buildTeamHomepageLinkFn(this, teamId);
            }

            /**
             * Returns a team-homepage link based on the specified team ID
             * @param {number | string} teamId Numeric team id, as a number or string
             * @return {string} The link, or null if the team is not recognized as an active team
             */

        }, {
            key: 'getTeamScheduleLinkFromTeamId',
            value: function getTeamScheduleLinkFromTeamId(teamId) {
                BamArgValidator$1.validateArgs(arguments, ['teamId'], ['string|number'], [true]);
                return this._buildTeamScheduleLinkFn(this, teamId);
            }

            /**
             * Returns a team-homepage link based on the statsapi team node
             * @param {object} statsapiTeam A statsapi team node, such as returned the Sports Data Teams or Schedule API
             * @return {string} The link, or null if the team is not recognized as an active team
             */

        }, {
            key: 'getTeamHomepageLink',
            value: function getTeamHomepageLink(statsapiTeam) {
                BamArgValidator$1.validateStatsapiTeam(statsapiTeam);
                return this.getTeamHomepageLinkFromTeamId(statsapiTeam.id);
            }

            /**
             * Returns a team slug such as "rangers" or "yankees"
             * @param {string | number} teamId A numeric team ID, as a string or number
             * @return {string} A team slug, or null if this is not a recognized active team.
             */

        }, {
            key: 'getTeamSlugFromTeamId',
            value: function getTeamSlugFromTeamId(teamId) {
                BamArgValidator$1.validateNumber(teamId);
                return this._teamData.getTeamSlug(parseInt(teamId));
            }

            /**
             * Returns a team slug such as "rangers" or "yankees" based on the statsapi team node
             * @param {object} statsapiTeam A statsapi team node, such as returned the Sports Data Teams or Schedule API
             * @return {string} The team slug, or null if the team is not recognized as an active team
             */

        }, {
            key: 'getTeamSlug',
            value: function getTeamSlug(statsapiTeam) {
                BamArgValidator$1.validateStatsapiTeam(statsapiTeam);
                return this.getTeamSlugFromTeamId(statsapiTeam.id);
            }

            /**
             * Returns a fully qualified team-logo-image URL.  Note that referencing team logos directly by URL may not be
             * the optimal way to use them; e.g. MLB uses sprites for most logo use cases.
             *
             * This superclass implementation throws an Error if called; subclasses must provide an implementation.
             *
             * @param {number | string} The numeric team ID, as a string or number. Pass zero for the league logo.
             * @param {boolean} darkBg Optional; true means the version of the logo meant for display on a dark background. The
             *   default is true.  Ignored if logos for the subclass property are not available in bark and light versions.
             * @param {string} logoType Optional, and may not apply to all properties.  MLB makes several logo types available
             *   (primary, hat, url, etc.), e.g.
             * @return {string}
             */

        }, {
            key: 'getFqTeamLogoUrl',
            value: function getFqTeamLogoUrl(teamId, darkBg, logoType) {
                Helpers$3.throwNotImplementedError('getFqTeamLogoUrl');
            }

            /**
             * Return the BamTeamData subclass backing this BamLinker
             * @return {BamTeamData}
             */

        }, {
            key: 'getBamTeamData',
            value: function getBamTeamData() {
                return this._teamData;
            }

            /**
             * Return the fully qualified URL of the site-core static-assets root, e.g. (for MLB)
             * //www.mlbstatic.com/mlb.com/builds/site-core/fe87f5c56891104097b778aa06b60f1a369ec4fd_1494355291.  The returned
             * URL will not have a trailing slash.  Strings starting with '/images', '/fonts', '/bower_components', '/scripts',
             * etc. are expected to be appended to the returned URL.  Usage:
             *
             * var imageUrl = linker.getFqPathToSiteCoreAssets() + '/images/globallyUsedImage.png';
             *
             * Note that this method cannot be used to reference section-specific assets; these URLs have a different
             * structure, and also contain different build versions.  For that, use getFqPathToSectionAssets().
             *
             * This superclass implementation throws an Error if called; subclasses must provide an implementation.
             *
             * @return {string}
             */

        }, {
            key: 'getFqPathToSiteCoreAssets',
            value: function getFqPathToSiteCoreAssets() {
                Helpers$3.throwNotImplementedError('getFqPathToSiteCoreAssets');
            }

            /**
             * Return the fully qualified URL of the current section's static-assets root, e.g. (for MLB)
             * //www.mlbstatic.com/mlb.com/sections/club-schedule/builds/c47203dcaf2560531a98f3471b9972f1b9e6f492_1494356470.
             * The returned URL will not have a trailing slash.  Strings starting with '/images' or any other directories your
             * section exposes in its section_config.json are expected to be appended to the returned URL.  Usage:
             *
             * var imageUrl = linker.getFqPathToSectionAssets() + '/images/sectionSpecificImage.png';
             *
             * Note that this method cannot be used to reference global (site-core) assets; these URLs have a different
             * structure, and also contain different build versions.  For that, use getFqPathToSiteCoreAssets().
             *
             * This superclass implementation throws an Error if called; subclasses must provide an implementation.
             *
             * @return {string}
             */

        }, {
            key: 'getFqPathToSectionAssets',
            value: function getFqPathToSectionAssets() {
                Helpers$3.throwNotImplementedError('getFqPathToSectionAssets');
            }

            /**
             /**
             * Static method which, passed either a BANE-controller <code>req</code> or a BANE browser <code>window</code>,
             * returns an array of teams
             * in statsapi format (see e.g. http://qa-statsapi.mlb.com/api/v1/teams/?sportId=1).  Returns null if a team array
             * could not be found.
             * @param {object} ctx A BANE controller request or browser window
             * @param clientArrAsDotNotatedStr e.g. "team_info" if arr is window.team_info
             * @param serverArrAsDotNotatedStr e.g. "path.to.teamArr" if arr is req.path.to.teamArr
             * @return {Array} A copy of the array found in ctx, or null
             */

        }], [{
            key: 'getTeamArrayFromReqOrWindow',
            value: function getTeamArrayFromReqOrWindow(ctx, clientArrAsDotNotatedStr, serverArrAsDotNotatedStr) {
                return BamTeamData$1.getTeamArrayFromReqOrWindow(ctx, clientArrAsDotNotatedStr, serverArrAsDotNotatedStr);
            }
        }, {
            key: 'getHelpers',
            value: function getHelpers() {
                return Helpers$3;
            }
        }]);

        return BamLinker$1;
    }();

    var Helpers$5 = BamLinker$1.getHelpers();

    /**
     * Static functions which override functions defined in bam-linker/lib/DefaultFunctions.  In all cases,
     * these functions (and those in DefaultFunctions noted above) are passed as options to the MlbLinker
     * constructor.
     *
     * Consumers are not expected to invoke any of these functions directly, but they may be useful for reference.
     */

    var FunctionOverrides = function () {
        function FunctionOverrides() {
            _classCallCheck(this, FunctionOverrides);
        }

        _createClass(FunctionOverrides, null, [{
            key: 'buildPlayerPageLink',


            /**
             * Builds a aws player-page link.
             * @param {MlbLinker} linker The current MlbLinker instance
             * @param {object | null} statsapiPerson; required
             * @param fullname e.g. John Smith; optional
             * @param playerId Numeric player ID; optional
             * @return {string}
             */
            value: function buildPlayerPageLink(linker, statsapiPerson) {
                var fullname = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                var id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

                return linker.getLink('/player/' + linker._buildPlayerSlugFn(linker, statsapiPerson, fullname, id), false);
            }

            /**
             * @param {MlbLinker} linker The current MlbLinker instance
             * @param {object | null} statsapiPerson; required
             * @param fullname e.g. John Smith; optional
             * @param playerId Numeric player ID; optional
             * @return {string} e.g. "12345678" or "first-last-12345678"
             */

        }, {
            key: 'buildPlayerSlug',
            value: function buildPlayerSlug(linker, statsapiPerson) {
                var fullname = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                var id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

                var slug = '';

                if (statsapiPerson && statsapiPerson.nameSlug) {
                    slug = statsapiPerson.nameSlug;
                } else if (id !== '') {
                    slug = id;
                }

                return slug;
            }

            /**
             * Returns a team-homepage URL.  Current team-homepage URLs are JSP for the desktop site, v2 for the mobile site.
             * Thus this function will return fully qualified URLs in one of these formats: http://m.yankees.mlb.com (v2), or
             * http://newyork.yankees.mlb.com/index.jsp?c_id=nyy (JSP).
             * @param {MlbLinker} linker The current MlbLinker instance
             * @param {string | number} teamId The numeric ID of the team, as a string or number
             * @return {string} A team-homepage link, in one of two formats depending on the client (see above).
             */

        }, {
            key: 'buildTeamHomepageLink',
            value: function buildTeamHomepageLink(linker, teamId) {
                if (linker._isMilb) {
                    var _teamId = teamId || linker._teamId;
                    if (!_teamId || typeof _teamId !== 'number') {
                        return null;
                    }
                    var slug = linker._teamSlugs && linker._teamSlugs[_teamId];

                    if (linker._isMlbPartner) return null;
                    return slug ? linker.getLink('/' + slug, false) : linker._milbHostName + '/index.jsp?sid=t' + _teamId;
                }

                if (!linker._teamData.isTeamExists(teamId)) {
                    return null;
                }

                return linker.getLink(linker._teamData.getTeamSlug(teamId), false);
            }

            /**
             * Override to build correct generic url in both mlb and milb context
             * @param {MlbLinker} linker The current MlbLinker instance
             * @param {string | number} urlSegment urlSegment The segment to append to the base URL.
             * e.g. "/player/some-player-121212". Segments which don't start with a forward-slash get
             * one prepended automatically.
             * @param {boolean} keepTeam If true and the current request's teamId is not zero (meaning, there's currently a
             * team segment on the URL), that segment will be preserved for the returned URL. 
             * If false, it won't be. The default is true.
             * @return {string}
             */

        }, {
            key: 'buildLink',
            value: function buildLink(linker, urlSegment, keepTeam) {
                BamArgValidator$1.validateArgs(arguments, ['linker', 'urlSegment', 'keepTeam'], ['object', 'string', 'boolean'], [true, true, false]);
                var url = void 0;
                if (linker._isMilb) {
                    url = (linker._baseUrl || '') + (linker._appView === 'web' ? '' : '/' + linker._appView) + (linker._langCode === 'en' ? '' : '/' + linker._langCode) + (keepTeam ? linker._slug ? '/' + linker._slug : '' : '') + urlSegment;
                } else {
                    url = linker._appViewPathEl + linker._langCodePathEl + (keepTeam ? linker._teamPathEl : '') + urlSegment;
                }

                return url;
            }
        }]);

        return FunctionOverrides;
    }();

    var DEFAULT_ID_STR = '000';
    var AL_ID_STR = '159';
    var NL_ID_STR = '160';

    var data = {
        mappings: {
            // AL:
            5529: AL_ID_STR, // 4/5 Winner
            5528: AL_ID_STR, // 3/6 Winner
            5527: AL_ID_STR, // 2/7 Winner
            5526: AL_ID_STR, // 1/8 Winner
            5518: AL_ID_STR, // Div. Run Up (4)
            5519: AL_ID_STR, // Div. Run Up (5)
            5520: AL_ID_STR, // Div. Run Up (6)
            5513: AL_ID_STR, // Wild Card (8)
            4614: AL_ID_STR, // Div. Winner #1
            4615: AL_ID_STR, // Div. Winner #2
            4616: AL_ID_STR, // Div. Winner #3
            4944: AL_ID_STR, // Higher Seed
            4945: AL_ID_STR, // Lower Seed
            4612: AL_ID_STR, // Wild Card
            3370: AL_ID_STR, // TBD - DS 'A'
            3371: AL_ID_STR, // TBD - DS 'B'
            21: AL_ID_STR, // League Champion

            // NL:
            5533: NL_ID_STR, // 4/5 Winner
            5532: NL_ID_STR, // 3/6 Winner
            5531: NL_ID_STR, // 2/7 Winner
            5530: NL_ID_STR, // 1/8 Winner
            5522: NL_ID_STR, // Div. Run Up (4)
            5523: NL_ID_STR, // Div. Run Up (5)
            5524: NL_ID_STR, // Div. Run Up (6)
            5517: NL_ID_STR, // Wild Card (8)
            4617: NL_ID_STR, // Div. Winner #1
            4618: NL_ID_STR, // Div. Winner #2
            4619: NL_ID_STR, // Div. Winner #3
            4946: NL_ID_STR, // Higher Seed
            4947: NL_ID_STR, // Lower Seed
            4613: NL_ID_STR, // Wild Card
            3372: NL_ID_STR, // TBD - DS 'A'
            3373: NL_ID_STR, // TBD - DS 'B'
            31: NL_ID_STR, // League Champion

            // Generic: The two teams playing in the WS, _before_ we know which league's pennant winner will be the home
            // team (once known, team IDs 21 and 31 - see above - are used).  Not strictly necessary to map these to
            // DEFAULT_ID_STR because this is the default anyway; just being explicit:
            2710: DEFAULT_ID_STR, // League Champion #1
            2711: DEFAULT_ID_STR // League Champion #2
        },
        defaultIdStr: DEFAULT_ID_STR,
        alIdStr: AL_ID_STR,
        nlIdStr: NL_ID_STR
    };

    var MlbTbdTeamToLeagueMap$1 = function () {

        /**
         * @throws `Error` if called; this class cannot be instantiated.
         */
        function MlbTbdTeamToLeagueMap$1() {
            _classCallCheck(this, MlbTbdTeamToLeagueMap$1);

            throw new Error('MlbTbdTeamToLeagueMap cannot be instantiated.');
        }

        /**
         * Passed the ID of a "TBD team" (pseudo-teams which exist in MLB data for postseason games until it is known
         * which actual teams will play in those games), returns one of these strings: "103" (AL); "104" (NL); or "000"
         * (the default, if the ID isn't recognized, or if it's ID 2710 or 2711 (the two world-series clubs before we know
         * which league will be home/away), or if it's simply invalid input.  These three possible return values are
         * expected to be used to build logo URLs; the reason for the padded "000" is that "000.svg" is the generic icon
         * depicting a baseball.
         *
         * Note that "000.svg" is found (as of 9/11/2017) in "/images/logos/team-cap-on-[dark/light]/", while "103.svg"
         * and "104.svg" are found elsewhere (currently as of 9/11/2017) only in "/images/logos/league-on-light/".
         *
         * Also see `getLeagueInfoFromTbdTeamId()` in this class, a lower-level method which may be cleaner to work with,
         * depending on usage.
         *
         * Helpful info is here: https://jira.mlbam.com/browse/SSSS-4943
         *
         * @param {number|string} teamId The ID of a "TBD team" such as 4617 ("NL Div. Winner #1").  May be a number, or a
         *      string representation of a number.
         * @return {string} One of "103", "104", or "000"
         * @see MlbTbdTeamToLeagueMap.getLeagueInfoFromTbdTeamId
         */


        _createClass(MlbTbdTeamToLeagueMap$1, null, [{
            key: 'getLeagueIdFromTbdTeamId',
            value: function getLeagueIdFromTbdTeamId(teamId) {
                var leagueInfo = MlbTbdTeamToLeagueMap$1.getLeagueInfoFromTbdTeamId(teamId);
                return leagueInfo.unknownLeague ? data.defaultIdStr : leagueInfo.leagueId;
            }

            /**
             * A lower-level but generally cleaner alternative to the `getLeagueIdFromTbdTeamId()` method in this class.
             * Passed a `teamId`
             * expected to be the ID of a "TBD team" (pseudo-team which exists in MLB data for postseason games until it is
             * known which actual active teams will play in those games), returns ab object with two
             * properties: `unknownLeague`, a boolean indicating whether this TBD team is associated with a league or not; and
             * `leagueId`, the ID (as a string) of the league if `unknownLeague` is true - otherwise this property should be
             * ignored.
             *
             * Helpful info is here: https://jira.mlbam.com/browse/SSSS-4943
             *
             * @param {number|string} teamId The ID of a "TBD team" such as 4617 ("NL Div. Winner #1").  May be a number, or a
             *      string representation of a number.
             * @return {{unknownLeague: boolean, leagueId: string}}
             * @see https://jira.mlbam.com/browse/SSSS-4943
             */

        }, {
            key: 'getLeagueInfoFromTbdTeamId',
            value: function getLeagueInfoFromTbdTeamId(teamId) {
                var teamIdNum = parseInt('' + teamId);

                if (isNaN(teamIdNum)) {
                    teamIdNum = 0;
                }
                var isRecognizedLeagueId = !!data.mappings[teamIdNum];
                var leagueIdStr = data.mappings[teamIdNum] || data.defaultIdStr;
                var isLeagueId = leagueIdStr !== data.defaultIdStr;
                return {
                    unknownLeague: !isLeagueId,
                    isRecognizedLeagueId: isRecognizedLeagueId,
                    leagueId: isLeagueId ? leagueIdStr : null
                };
            }

            /**
             * Returns true if this is a postseason "tbd team", false if it's anything else (an active team; a formerly active
             * team; one of the ASG teams; an xref team; bad input; etc.).
             * @param {number|string} teamId Numeric team ID, as a number or string.
             * @return {boolean}
             */

        }, {
            key: 'isTbdTeam',
            value: function isTbdTeam(teamId) {
                var leagueInfo = MlbTbdTeamToLeagueMap$1.getLeagueInfoFromTbdTeamId(teamId);
                return !leagueInfo.unknownLeague || leagueInfo.isRecognizedLeagueId;
            }
        }]);

        return MlbTbdTeamToLeagueMap$1;
    }();

    var Helpers = BamLinker$1.getHelpers();
    var cloneDeep = MlbTeamData$1.getHelpers().cloneDeep;

    var generatorConstructorOptions = {
        buildLinkFn: FunctionOverrides.buildLink,
        buildPlayerPageLinkFn: FunctionOverrides.buildPlayerPageLink,
        buildPlayerSlugFn: FunctionOverrides.buildPlayerSlug,
        buildTeamHomepageLinkFn: FunctionOverrides.buildTeamHomepageLink,
        // the required options, which we derive later:
        langCode: null,
        deviceType: null,
        teamId: null,
        appView: null
    };

    // game.gamedayType values that should not link to gameday
    var HIDDEN_GAMEDAY_TYPES = {
        N: true,
        L: true,
        S: true
    };

    var AL_ID = 103;
    var NL_ID = 104;
    var AL_ASG_TEAM_ID = 159;
    var NL_ASG_TEAM_ID = 160;

    /**
     * MLB-specific subclass of BamLinker extended to support MiLB.  Returns team-homepage links, player-page links, and
     * generic links.  This BamLinker subclass is different from others, since it must work for BANE pages which live
     * within the context of a larger MLB.com, all of which has not yet been converted to BANE.
     *
     * In order to use the MlbLinker in the MiLB context, pass a truthy value for isMilb in your options object.
     * E.g: window.milbLinker = new MlbLinker(window, { isMilb: true });
     *
     * Thus, for example,
     * player-page links are fully qualified, as they currently still live on the v2/responsive site.  So it can generate
     * these fully qualified URLs, this class knows how to build both team-specific and league-level hostnames for both
     * JSP/wired (e.g. http://newyork.yankees.mlb.com) and v2/responsive (e.g. http://m.yankees.mlb.com) sites.
     *
     * Also, what this class defines as a player "slug" is "12345678/first-last" (or possibly
     * just "12345678"); in BANE style, a "slug" always contains the player ID, where as on the legacy MLB sites, "slug"
     * more likely referred to just "first-last".
     *
     * Implementation note: most of the methods in this class (and all of the methods which override methods in
     * BamLinker) are just calls to their supermethods (with all of the MLB-specific behavior coming from the way
     * we call the superconstructor and the MlbTeamData constructor - different options, different behavior - not from
     * differing implementations of the overriding methods).  As such,
     * their "implementations" (just supermethod calls) don't need to be in this class at all.  They're here, though, so we
     * can JSDoc them -
     * in most cases, the difference between MLB-specific behavior and property-agnostic behavior is not the default
     * behavior.
     *
     * @extends BamLinker
     */

    var MlbLinker = function (_BamLinker$) {
        _inherits(MlbLinker, _BamLinker$);

        /**
         * @param windowOrReq A `window` or a BANE-controller `req`; optional - if not passed, a browser window object will
         *   be assumed to be the context.
         * @param options Optional; supported options:
         *   - langCodeOverride: a string overriding the default langCode (which is taken from the context).
         */
        function MlbLinker(windowOrReq) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _classCallCheck(this, MlbLinker);

            var genOpts = cloneDeep(generatorConstructorOptions);

            // TEMP:
            genOpts.fqSiteCorePrefixUrl = '/site-core';

            // We use this generic BANE method to derive and add appView, langCode, deviceType, and teamId; should the need
            // arise in future for different behavior, we'd switch to MLB-specific logic.

            var ctx = windowOrReq;
            if (!ctx) {
                if (!!window) {
                    ctx = window;
                } else {
                    throw new Error('windowOrReq was null or undefined, and no window object was found to use by default.');
                }
            }

            Helpers.addRequestSpecificOptions(genOpts, ctx, true);

            if (options.langCodeOverride) {
                genOpts.langCode = options.langCodeOverride;
            }

            var _this2 = _possibleConstructorReturn(this, (MlbLinker.__proto__ || Object.getPrototypeOf(MlbLinker)).call(this, options.isMilb ? {} : new MlbTeamData$1(windowOrReq, []), genOpts));

            if (_this2._clientSide) {
                _this2._metaTags = windowOrReq.document.getElementsByTagName('meta');
            }

            if (options.isMilb) {
                _setMilbProperties(_this2, windowOrReq, options);
            }

            _this2._siteCoreLogosRoot = _this2.getFqPathToSiteCoreAssets() + '/images/logos/';
            return _this2;
        }

        /**
         * Return a link to another BANE page, preserving language, app-view, and team (if keepTeam is true). _Use
         * `getLegacyLink()` in this class to build links to JSP/wired or v2/responsive pages._
         *
         * Note: please use this method only when there isn't a link-type-specific method (e.g.,
         * `getPlayerPageLink()`) that meets your needs.
         *
         * @param {string} urlSegment e.g. /schedule; should never contain app-view or lang path segments (/fr, /app, etc.).
         * Forward-slash will be prepended if not passed.
         * @param {boolean} keepTeam If true, the team-slug URL segment (if any) will be preserved. Default is true.
         * @return {string}
         */


        _createClass(MlbLinker, [{
            key: 'getLink',
            value: function getLink(urlSegment, keepTeam) {

                return _get(MlbLinker.prototype.__proto__ || Object.getPrototypeOf(MlbLinker.prototype), 'getLink', this).call(this, urlSegment, keepTeam);
            }

            /**
             * Return a URL in one of two legacy formats: "jsp" (http://newyork.yankees.mlb.com/fan_forum/index.jsp?c_id=nyy) or
             * "v2" (http://m.yankees.mlb.com/roster).
             *
             * Note: please use this method only when there isn't a link-type-specific method (e.g.,
             * `getPlayerPageLink()`) that meets your needs.
             *
             * Note: By default the langCode will be removed from the link.
             *       If you want to add the lang code back, please use `legacyLinkInsertLang`
             *
             * @param {string} urlSegment e.g. /scoreboard; should never contain app-view or lang path segments (/fr, /app,
             * etc.). Forward-slash will be prepended if not passed.
             * @param {boolean} keepTeam True to stay on this team's site (if we're on one to begin with), false to go
             *   to the league site.  Required.
             * @param {'jsp' | 'v2'} siteType One of 'jsp' or 'v2'. Required.
             * @param {string} alternateBaseUrl A URL (never with a trailing forward-slash) to use as the start of the URL
             *   instead of the default (either, e.g.,
             *   http://newyork.yankees.mlb.com or http://mlb.mlb.com (JSP) or http://m.yankees.mlb.com or http://m.mlb.com
             *   (v2).  For example, getGamedayLink() needs to link to a (sort-of) origin server, www.mlb.com, as opposed to
             *   mlb.mlb.com; thus it passes "http://www.mlb.com".
             * @return {string}
             */

        }, {
            key: 'getLegacyLink',
            value: function getLegacyLink(urlSegment, keepTeam, siteType, alternateBaseUrl) {
                BamArgValidator$1.validateArgs(arguments, ['urlSegment', 'keepTeam', 'siteType', 'alternateBaseUrl'], ['string', 'boolean', 'string', 'string'], [true, true, true, false]);
                var baseUrl = void 0;
                var teamId = keepTeam ? this._teamId : 0;
                var tricode = this._teamData.getTeamTricodeFromId(teamId);
                if (alternateBaseUrl) {
                    if (alternateBaseUrl.charAt(alternateBaseUrl.length - 1) === '/') {
                        throw new Error('alternateBaseUrl ends with a forward-slash; this is not allowed.');
                    }
                    baseUrl = alternateBaseUrl;
                } else {
                    baseUrl = this._teamData[siteType === 'jsp' ? 'getBaseJspUrl' : 'getBaseV2Url'](teamId);
                }

                // we'll see how this works - or if it matters; may need more involved logic:
                var url = baseUrl + this.getLink(urlSegment, false);
                if (siteType === 'jsp' && teamId !== 0) {
                    if (url.indexOf('?') === -1) {
                        url += '?';
                    } else {
                        url += '&';
                    }
                    url += 'c_id=' + tricode;
                }

                return MlbLinker.stripLanguagePathElement(url);
            }

            /**
             * Generate a gameday link for the specified game, in the specified mode (wrap, preview, etc.), for example:
             * http://www.mlb.com/r/game?gid=2016_08_16_bosmlb_balmlb_1&mode=wrap&sport_code=mlb (with "wrap" being the `mode`
             * param in this example).
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @param {boolean} ignoreGameState=false If true, return gameday link for final or suspended games
             * @return {string} A gameday link or null
             */

        }, {
            key: 'getGamedayLink',
            value: function getGamedayLink(statsapiGame) {
                var ignoreGameState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


                BamArgValidator$1.validateStatsapiGame(statsapiGame);

                var _statsapiGame$status = statsapiGame.status,
                    status = _statsapiGame$status === undefined ? {} : _statsapiGame$status,
                    gamedayType = statsapiGame.gamedayType;


                if (!ignoreGameState) {

                    if (status.abstractGameCode === 'F' || status.codedGameState === 'S') {

                        return null;
                    }
                }

                if (HIDDEN_GAMEDAY_TYPES[gamedayType]) {

                    return null;
                }

                return this.getLink('/gameday/' + statsapiGame.gamePk, false);
            }

            /**
             * If a recap article exists, provide a wrap link
             * Once https://jira.mlbam.com/browse/SDBBD-2213 is complete, check for wrap article
             * @param statsapiGame
             * @return {string}
             */

        }, {
            key: 'getWrapLink',
            value: function getWrapLink(statsapiGame, sId) {

                BamArgValidator$1.validateStatsapiGame(statsapiGame);
                var _statsapiGame$content = statsapiGame.content,
                    content = _statsapiGame$content === undefined ? {} : _statsapiGame$content,
                    season = statsapiGame.season;


                if (content.summary) {
                    var _content$summary = content.summary,
                        hasRecapArticle = _content$summary.hasRecapArticle,
                        hasWrapArticle = _content$summary.hasWrapArticle;


                    if (hasRecapArticle || hasWrapArticle) {
                        return this._isMilb ? this.getStatsLink(statsapiGame, sId) : this.getLink('/gameday/' + statsapiGame.gamePk + '/final/wrap', false);
                    }
                }

                return null;
            }

            /**
             * If a game is in pregame, return a gameday preview link, otherwise null
             * If a plain gameday link is available, don't return a preview link
             * @param statsapiGame
             * @return {string}
             */

        }, {
            key: 'getPreviewLink',
            value: function getPreviewLink(statsapiGame) {
                var url = void 0;

                BamArgValidator$1.validateStatsapiGame(statsapiGame);

                if (statsapiGame.status) {

                    var code = statsapiGame.status.abstractGameCode;

                    if (code && code === 'P') {

                        var gameDayLink = this.getGamedayLink(statsapiGame);

                        if (!gameDayLink) {
                            return this.getLink('/gameday/' + statsapiGame.gamePk + '/preview', false);
                        }
                    }
                }

                return null;
            }

            /**
             * Return a gameday deep link, otherwise null
             * @param statsapiGame
             * @return {string}
             */

        }, {
            key: 'getDeviceDeepLink',
            value: function getDeviceDeepLink(statsapiGame) {

                BamArgValidator$1.validateStatsapiGame(statsapiGame);

                if (statsapiGame.gamePk) {

                    return 'mlbatbat://game?gamepk=' + statsapiGame.gamePk;
                }

                return null;
            }

            /**
             * If a game is final (and not postponed or canceled) return a gameday boxscore link, otherwise null
             * @param statsapiGame
             * @return {string}
             */

        }, {
            key: 'getBoxscoreLink',
            value: function getBoxscoreLink(statsapiGame) {
                var validateGame = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                var url = this.getLink('/gameday/' + statsapiGame.gamePk + '/final/box', false);

                if (validateGame) {
                    BamArgValidator$1.validateStatsapiGame(statsapiGame);

                    if (statsapiGame.status) {

                        var code = statsapiGame.status.abstractGameCode;

                        if (code && code === 'F') {

                            var statusCode = statsapiGame.status.statusCode;
                            var firstLetter = statusCode && statusCode.charAt(0) || '';

                            // Don't link to boxscore for postponed or canceled games (SSSS-3725)
                            if (firstLetter && firstLetter !== 'D' && firstLetter !== 'C') {
                                return url;
                            }
                        }
                    }
                } else {

                    if (statsapiGame && statsapiGame.gamePk) {
                        return url;
                    }
                }

                return null;
            }

            /**
             * If a game is live, return box score link (MiLB Complex Leagues // gamedayType === 'N')
             * @param statsapiGame
             * @return {string}
             */

        }, {
            key: 'getLiveBoxLink',
            value: function getLiveBoxLink(statsapiGame) {
                var _statsapiGame$status2 = statsapiGame.status,
                    status = _statsapiGame$status2 === undefined ? {} : _statsapiGame$status2,
                    gamePk = statsapiGame.gamePk,
                    gamedayType = statsapiGame.gamedayType;


                if (gamedayType === 'N' && gamePk && status.abstractGameCode === 'L') {
                    return this.getLink('/gameday/' + gamePk, false);
                }

                return null;
            }

            /**
             * Generate a press-notes link such as http://mlb.com/mlb/presspass/gamenotes.jsp?c_id=mlb. While press-notes links
             * are currently game-agnostic, this method takes a game node for future possible compatibility, which shouldn't
             * be an issue since wherever press-notes links appear, other links will appear as well which will require a
             * `statsapiGame`.
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @return {string} A press-notes link
             */

        }, {
            key: 'getPressNotesLink',
            value: function getPressNotesLink(statsapiGame) {
                BamArgValidator$1.validateStatsapiGame(statsapiGame);
                return 'http://mlb.com/mlb/presspass/gamenotes.jsp?c_id=mlb';
            }

            /**
             * Generates a tickets link based on game; whether user is desktop or mobile; what the current team is (we don't
             * yet handle league sites here, just club sites); and what types of links are available from statsapi (e.g., if
             * there's no mobile-specific link, we return the desktop link, etc.).
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @return {string}
             */

        }, {
            key: 'getTicketsLink',
            value: function getTicketsLink(statsapiGame) {
                return _getTicketsLink(statsapiGame, arguments.length > 1 ? arguments[1] : false, this, 'any');
            }

            /**
             * Generates a tickets link for club schedukle app view based on game;
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @return {string}
             */

        }, {
            key: 'getAppViewTicketLink',
            value: function getAppViewTicketLink(statsapiGame) {
                var _ref = statsapiGame || {},
                    gamePk = _ref.gamePk,
                    teams = _ref.teams;

                if (!gamePk || !teams) {
                    return null;
                }

                var teamId = teams && teams.home && teams.home.team && teams.home.team.id;

                if (!teamId || typeof teamId !== 'number') {
                    return null;
                }

                var teamslug = this._isMilb ? this._teamSlugs && this._teamSlugs[teamId] : this._teamData.getTeamSlug(teamId);
                return teamslug ? this.getLink('/' + teamslug + '/tickets?game_pk=' + gamePk, false) : null;
            }

            /**
             * Generates a tickets link based on game; base on appView we call different functions
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @return {string}
             */

        }, {
            key: 'getClubScheduleTicketLink',
            value: function getClubScheduleTicketLink(statsapiGame) {
                if (this._isMilb) {
                    return this.getTicketsLink(statsapiGame);
                }
                return this._appView === 'web' ? this.getTicketsLinkForContextTeam(statsapiGame) : this.getAppViewTicketLink(statsapiGame);
            }

            /**
             * Generates a tickets link based on game; base on appView we call different functions
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @return {string}
             */

        }, {
            key: 'getClubScheduleTicketLinkNotForContextTeam',
            value: function getClubScheduleTicketLinkNotForContextTeam(statsapiGame) {
                return this._appView === 'web' ? this.getTicketsLinkNotForContextTeam(statsapiGame) : this.getAppViewTicketLink(statsapiGame);
            }

            /**
             * Returns a ticket link IF AND ONLY IF there is one available which will take the user to a site where they can
             * purchase tickets from the context team (the team whose site they're visiting).  This method is meant to be used
             * in conjunction with getTicketsLinkNotForContextTeam(), which returns the "opposite" of what this method returns:
             * only non-context-team ticket links.
             *
             * This method (and its cousin getTicketsLinkNotForContextTeam()) are meant to be used instead of getTicketsLink()
             * when the consumer must know whether they're dealing with a context-team link or an opponent-team link (since in
             * some cases, we alert the user to the fact that they'll be purchasing tickets from the opponent if they proceed.
             * Expected use" consumer calls this method first; if it returns null, they call getTicketsLinkNotForContextTeam()
             * and offer the return value (if not null ofc) to the user, but telling them this is the opponent's link.
             * @param statsapiGame
             * @return {string} A url, or null if a ticket link meeting the criteria described above is not available
             */

        }, {
            key: 'getTicketsLinkForContextTeam',
            value: function getTicketsLinkForContextTeam(statsapiGame) {
                return _getTicketsLink(statsapiGame, arguments.length > 1 ? arguments[1] : false, this, 'contextOnly');
            }

            /**
             * @see #getNGETicketsLinkForContextTeam - where that method returns links to buy tickets from the context team, this
             *   method returns links to buy tickets from the opponent team.
             * @param statsapiGame
             */

        }, {
            key: 'getNGETicketsLinkForContextTeam',
            value: function getNGETicketsLinkForContextTeam(statsapiGame) {
                return _getTicketsLink(statsapiGame, arguments.length > 1 ? arguments[1] : false, this, 'opponentOnly', true);
            }

            /**
             * @see #getTicketsLinkForContextTeam - where that method returns links to buy tickets from the context team, this
             *   method returns links to buy tickets from the opponent team.
             * @param statsapiGame
             */

        }, {
            key: 'getTicketsLinkNotForContextTeam',
            value: function getTicketsLinkNotForContextTeam(statsapiGame) {
                return _getTicketsLink(statsapiGame, arguments.length > 1 ? arguments[1] : false, this, 'opponentOnly');
            }

            /**
             * Private method which returns a link to audio or video for this game (home media for home team, away media for
             * away team), or null if there is none
             * @param statsapiGame
             * @param {string} mediaTitle E.g. "MLBTV" for MLB TV, "Audio" for audio
             * @param {boolean} matchLanguage Optional; default is true. True to return a link only if one is found for the
             *   user's language; false to return links for any language.
             * @return {string}
             * @private
             */

        }, {
            key: '_getMediaLink',
            value: function _getMediaLink(statsapiGame, mediaTitle) {
                var matchLanguage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                var slugOption = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

                var lcMediaTitle = mediaTitle.toLowerCase();
                var mediaLink = null;
                var teamslug = this._teamData.getTeamSlug(this._teamId);

                if (statsapiGame.content && statsapiGame.content.media && statsapiGame.content.media.epg) {
                    var epgs = statsapiGame.content.media.epg;
                    var lcHomeAway = '';

                    if (this._teamId) {
                        lcHomeAway = statsapiGame.teams.home.team.id === this._teamId ? 'home' : 'away';
                    }

                    var eLength = epgs.length;

                    for (var eIdx = 0; eIdx < eLength; eIdx++) {

                        var epg = epgs[eIdx];

                        if (epg.title.toLowerCase() === lcMediaTitle && epg.items) {

                            var items = epg.items;
                            var iLength = items.length;

                            for (var iIdx = 0; iIdx < iLength; iIdx++) {
                                var item = items[iIdx];
                                var lcMediaFeedType = (item.type || item.mediaFeedType || '').toLowerCase();
                                var language = item.language ? item.language.toLowerCase() : '';
                                var isMediaOnOrArchive = item.mediaState === 'MEDIA_ON' || item.mediaState === 'MEDIA_ARCHIVE';
                                var isValidMediaFeedType = lcMediaFeedType === 'home' || lcMediaFeedType === 'away' || lcMediaFeedType === 'national';

                                if ((!matchLanguage || language === this._langCode) && isMediaOnOrArchive && (!item.youtube || item.youtube && item.mediaState !== 'MEDIA_ON') && (!item.facebook || item.facebook && item.mediaState !== 'MEDIA_ON')) {

                                    var gamePk = statsapiGame.gamePk || '';
                                    var isAudio = lcMediaTitle === 'audio';
                                    var audioQueryStr = isAudio ? '?mediatype=audio' : '';
                                    var teamslugStr = teamslug ? '/' + teamslug : '';

                                    if (gamePk) {
                                        mediaLink = (slugOption ? teamslugStr : '') + '/tv/g' + gamePk + audioQueryStr;
                                    } else {
                                        mediaLink = '';
                                        console.error('MlbLinker: _getMediaLink: Missing gamepk or contentId');
                                    }

                                    if (isValidMediaFeedType) {
                                        return mediaLink;
                                    }
                                }
                            }
                        }
                    }
                }

                return mediaLink;
            }

            /**
             *
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @param {boolean} currentLanguageOnly True to match the user's language, false to try to match it but return
             *    a different language if user's language is not found. Optional; default is false.
             * @return An audio URL, or null if none found
             */

        }, {
            key: 'getAudioLink',
            value: function getAudioLink(statsapiGame, currentLanguageOnly) {
                if (this._isMilb) {
                    var platform = statsapiGame || null;
                    return this._getMilbAudioLink(statsapiGame);
                }

                var url = this._getMediaLink(statsapiGame, 'Audio', true);
                if (!url && !currentLanguageOnly) {
                    url = this._getMediaLink(statsapiGame, 'Audio', false);
                }
                return url;
            }

            /**
             * Milb override for getAudioLink function.
             * @param {string} platform Optional platform string (ios, android) for device-specific targeting
             * @return {string} url path
             */

        }, {
            key: '_getMilbAudioLink',
            value: function _getMilbAudioLink() {
                var platform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                var _teamId = this._teamId;
                if (this._appView !== 'web') {
                    return this._milbMobileHostName + '/gdaudio/' + (platform || 'iphone');
                }
                return this._milbHostName + '/milb/multimedia/audio.jsp?sid=t' + _teamId;
            }

            /**
             * Private method called by getTvLink(), getTvLinkOrTvSubscriptionLink()
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @param {boolean} currentLanguageOnly True to match the user's language, false to try to match it but return
             *    a different language if user's language is not found. Optional; default is false.
             * @param returnSubLinkIfNoMedia True to return subscription link if no media found, false to return null
             * @return {string} An MLB TV URL if media found; otherwise returns null or a subscription link based on value
             *    of returnSubLinkIfNoMedia
             * @private
             */

        }, {
            key: '_getMlbTvLink',
            value: function _getMlbTvLink(statsapiGame, currentLanguageOnly, returnSubLinkIfNoMedia, slugOption) {

                BamArgValidator$1.validateArgs(arguments, ['statsapiGame', 'currentLanguageOnly', 'returnSubLinkIfNoMedia', 'slugOption'], ['object', 'boolean', 'boolean', 'boolean'], [true, true, true, false]);

                var url = this._getMediaLink(statsapiGame, 'MLBTV', true, slugOption);

                if (!url && !currentLanguageOnly) {
                    url = this._getMediaLink(statsapiGame, 'MLBTV', false, slugOption);
                }

                var hasFacebookLink = this.getFacebookGameLink(statsapiGame);
                var hasYouTubeLink = this.getYouTubeGameLink(statsapiGame);

                if (url === null && returnSubLinkIfNoMedia && !hasFacebookLink && !hasYouTubeLink) {

                    url = this.getLegacyLink('/mlb/subscriptions/index.jsp?product=mlbtv', false, 'jsp', 'http://mlb.com');
                    url = this.legacyLinkInsertLang(url);
                }

                return url;
            }

            /**
             * Private method to return milb.tv link
             * @param {object} statsapiGame Statsapi game node returned by, e.g., the Schedule API
             * @param {boolean} liveStream boolean that signals whether this game is scheduled for streaming
             * @return {string} url path
             */

        }, {
            key: '_getMilbTvLink',
            value: function _getMilbTvLink(statsapiGame, liveStream) {
                var gamePk = statsapiGame.gamePk;
                var season = statsapiGame.season;
                var tvURL = '';

                // no milb.tv links before 2019
                if (parseInt(season, 10) > 2018) {
                    // check that game is scheduled for streaming unless we're asked only for live streams
                    if (statsapiGame.broadcasts && !liveStream) {
                        var b = void 0;
                        for (b = 0; b < statsapiGame.broadcasts.length; ++b) {
                            if (statsapiGame.broadcasts[b].id === 1765) {
                                // TODO: ADD DATE TO URL WHEN AWS GRID HAS FUTURE GAMES ON GRID AND DATE ROUTE
                                tvURL = '/live-stream-games';
                            }
                        }
                    }

                    // check media states
                    if (statsapiGame.content) {
                        var mediaOnOrArchive = false;
                        var epg = statsapiGame.content.media && statsapiGame.content.media.epg || [];
                        if (!Array.isArray(epg)) {
                            epg = [epg];
                        }
                        var hasMedia = epg.some(function (epgItem) {
                            if (epgItem.title === 'MiLBTV' && epgItem.items.length) {
                                return epgItem.items.some(function (item) {
                                    mediaOnOrArchive = item.mediaState === 'MEDIA_ON' || item.mediaState === 'MEDIA_ARCHIVE';
                                    // TODO UPDATE WITH ADDITIONAL MEDIA STATES WHEN THEY ARE ADDED
                                    return mediaOnOrArchive;
                                });
                            }
                            return false;
                        });
                        if (hasMedia) {
                            tvURL = '/live-stream-games/g' + gamePk;
                        }
                    }
                }

                if (tvURL.length > 0) {
                    return this.getLink(tvURL, false);
                } else {
                    return '';
                }
            }

            /**
             * @method getTvLink
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @param {boolean} currentLanguageOnly True to match the user's language, false to try to match it but return
             *    a different language if user's language is not found. Optional; default is false. In MiLB context, this
             *    param is == liveStream. See _getMilbTvLink for info about this parameter
             * @return An MLB TV URL, or null if none found
             */

        }, {
            key: 'getTvLink',
            value: function getTvLink(statsapiGame, currentLanguageOnly) {
                return this._isMilb ? this._getMilbTvLink(statsapiGame, currentLanguageOnly) : this._getMlbTvLink(statsapiGame, !!currentLanguageOnly, false, true);
            }

            /**
             * @method getNewTvLink
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @param {boolean} currentLanguageOnly True to match the user's language, false to try to match it but return
             *    a different language if user's language is not found. Optional; default is false.
             * @return An MLB TV URL without team slug, or null if none found
             */

        }, {
            key: 'getNewTvLink',
            value: function getNewTvLink(statsapiGame, currentLanguageOnly) {
                return this._getMlbTvLink(statsapiGame, !!currentLanguageOnly, false, false);
            }
            /**
             * Return a mlb.tv device deep link, otherwise null
             * @param statsapiGame
             * @return {string}
             */

        }, {
            key: 'getDeviceTvDeepLink',
            value: function getDeviceTvDeepLink(statsapiGame) {

                BamArgValidator$1.validateStatsapiGame(statsapiGame);

                if (statsapiGame.gamePk) {
                    var hasTvLink = this.getNewTvLink(statsapiGame);

                    if (hasTvLink) {
                        var date = statsapiGame.officialDate && statsapiGame.officialDate.replace(/-/g, '');

                        return 'mlbatbat://mlbtv?gamepk=' + statsapiGame.gamePk + (date ? '&date=' + date : '');
                    }
                }

                return null;
            }

            /**
             * @method getTvLinkOrTvSubscriptionLink
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @param {boolean} currentLanguageOnly True to match the user's language, false to try to match it but return
             *    a different language if user's language is not found. Optional; default is false.
             * @return An MLB TV URL, or a subscription link if none found
             */

        }, {
            key: 'getTvLinkOrTvSubscriptionLink',
            value: function getTvLinkOrTvSubscriptionLink(statsapiGame, currentLanguageOnly) {
                return this._getMlbTvLink(statsapiGame, !!currentLanguageOnly, true);
            }

            /**
             * Generate a video-highlights link for the specified game, e.g. http://m.mlb.com/video/?game_pk=448635
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @return {string} A highlights link.
             */

        }, {
            key: 'getVideoHighlightsLink',
            value: function getVideoHighlightsLink(statsapiGame) {
                BamArgValidator$1.validateStatsapiGame(statsapiGame);

                var _statsapiGame$content2 = statsapiGame.content,
                    content = _statsapiGame$content2 === undefined ? {} : _statsapiGame$content2;

                var url = null;

                if (content.summary) {
                    var hasHighlightsVideo = content.summary.hasHighlightsVideo;


                    if (hasHighlightsVideo) {

                        url = this.getLink('/gameday/' + statsapiGame.gamePk + '/final/video', false);
                    }
                } else if (content.highlights) {

                    if (Object.keys(content.highlights).length > 0) {

                        url = this.getLink('/gameday/' + statsapiGame.gamePk + '/final/video', false);
                    }
                }

                url = this.legacyLinkInsertLang(url);

                return url;
            }

            /**
             * Generate a VTP link for the specified MLB or MiLB content id, e.g. http://m.mlb.com/video/c-100018516561
             * @param videoId An id for the game
             * @return {string} A video link.
             */

        }, {
            key: 'getVideoLink',
            value: function getVideoLink(videoId) {

                return this._isMilb ? this._milbHostName + '/r/video?content_id=' + videoId : '/video/c-' + videoId;
            }

            /**
             * Generate a VTP link for the specified topic id and a video id, e.g. http://m.mlb.com/video/t-239279104/c-100018516561
             * @param videoId An id for the game
             * @return {string} A video link.
             */

        }, {
            key: 'getLiveLookIn',
            value: function getLiveLookIn(videoId) {

                return '/video/t-239279104/c-' + videoId;
            }

            /**
             * Returns a player-page link based on a statsapi person node.  As the player page has not been migrated to BANE
             * yet, the link is fully qualified, to the "v2" player-page implementation.
             * @param {object} statsapiPerson A statsapi person node
             * @param {string | number} teamId The player's team ID. tricode.  Optional; the returned URL will have a
             *   generic (non-team-specific) hostname if this is not supplied.
             * @param {string} platform Optional platform string (ios, android) for device-specific targeting
             * @return {string} The player-page link with a slug like 'first-last-12345678'
             */

        }, {
            key: 'getPlayerPageLink',
            value: function getPlayerPageLink(statsapiPerson, teamId) {
                var platform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                var url = void 0;
                if (this._isMilb) {
                    var _teamId = teamId || this._teamId;
                    if (this._appView !== 'web') {
                        return this._milbHostName + '/' + this._appView + '/player/' + statsapiPerson.id;
                    }
                    url = this._milbHostName + '/player/' + statsapiPerson.id;
                } else {
                    // We call the super here, but this subclass uses options to override how player slugs are derived:
                    url = _get(MlbLinker.prototype.__proto__ || Object.getPrototypeOf(MlbLinker.prototype), 'getPlayerPageLink', this).call(this, statsapiPerson, teamId);
                }

                return url;
            }

            /**
             * Milb specific method to returns a player-page link based on player ID and team ID.
             * @param {object} leader The player's leader object.
             * @return {string} The player-page link for example: http://www.milb.com/player/index.jsp?sid=t234&player_id=642715
             */

        }, {
            key: 'getPlayerPageLinkById',
            value: function getPlayerPageLinkById(leader) {
                var complexLeague = [121, 124, 130]; // DIGIT-1409 different player link on Complex leagues.
                var leagueId = leader.league.id;
                var playerPageLink = '';
                if (leader) {
                    var sid = leagueId && complexLeague.indexOf(leagueId) !== -1 ? 'milb' : 't' + leader.team.id;
                    playerPageLink = this._milbHostName + '/player/index.jsp?sid=' + sid + '&player_id=' + leader.person.id;
                }
                return playerPageLink;
            }

            /**
             * Returns a player-page link based on a full name, player ID and optional team ID.  As the player page has not
             * been migrated to BANE yet, the link is fully qualified, to the "v2" player-page implementation.
             * @param fullname e.g. John Smith; required
             * @param playerId Numeric player ID; required
             * @param {string | number} teamId The player's team ID. tricode.  Optional; the returned URL will have a
             *   generic (non-team-specific) hostname if this is not supplied.
             * @return {string} The player-page link with a slug like 'first-last-12345678'
             */

        }, {
            key: 'getPlayerPageLinkByNameAndId',
            value: function getPlayerPageLinkByNameAndId(fullname, playerId, teamId) {
                var url = _get(MlbLinker.prototype.__proto__ || Object.getPrototypeOf(MlbLinker.prototype), 'getPlayerPageLinkByNameAndId', this).call(this, fullname, playerId, teamId);

                return url;
            }

            /**
             * Returns a player slug such as '12345678/first-last'.  Note that this is not really a "slug" as we normally
             * think of it; the "slug" here would be "first-last" or, if in typical BANE format, "first-last-12345678".  But
             * this method is used to build player-page links, and those still live on the "v2" site.
             * @param {object} statsapiPerson A statsapi person
             * @return {string}
             */

        }, {
            key: 'getPlayerSlug',
            value: function getPlayerSlug(statsapiPerson) {
                return _get(MlbLinker.prototype.__proto__ || Object.getPrototypeOf(MlbLinker.prototype), 'getPlayerSlug', this).call(this, statsapiPerson);
            }

            /**
             * Returns a team-homepage link based on the specified team and whether or not we are responding to a mobile
             * request (desktop homepage format is http://newyork.yankees.mlb.com/index.jsp?c_id=nyy; mobile homepage format
             * is http://m.yankees.mlb.com/).  _Once our team homepages are BANE-ified, this method's implementation will be
             * changed to reflect that (thus, code changes won't be necessary)._
             * @param {number | string} teamId Numeric team id, as a number or string
             * @return {string} The link, or null if the team is not recognized as an active team
             */

        }, {
            key: 'getTeamHomepageLinkFromTeamId',
            value: function getTeamHomepageLinkFromTeamId(teamId) {
                return _get(MlbLinker.prototype.__proto__ || Object.getPrototypeOf(MlbLinker.prototype), 'getTeamHomepageLinkFromTeamId', this).call(this, teamId);
            }

            /**
             * Returns a team-schedule link based on the specified team.
             * @param {number | string} teamId Numeric team id, as a number or string
             * @return {string} The link, or null if the team is not recognized as an active team
             */

        }, {
            key: 'getTeamScheduleLinkFromTeamId',
            value: function getTeamScheduleLinkFromTeamId(teamId) {
                return _get(MlbLinker.prototype.__proto__ || Object.getPrototypeOf(MlbLinker.prototype), 'getTeamScheduleLinkFromTeamId', this).call(this, teamId);
            }

            /**
             * Returns a team-homepage link based on the specified team and whether or not we are responding to a mobile
             * request (desktop homepage format is http://newyork.yankees.mlb.com/index.jsp?c_id=nyy; mobile homepage format
             * is http://m.yankees.mlb.com/).  _Once our team homepages are BANE-ified, this method's implementation will be
             * changed to reflect that (thus, code changes won't be necessary)._
             * @param {object} statsapiTeam A statsapi team node, such as returned the Sports Data Teams or Schedule API
             * @return {string} The link, or null if the team is not recognized as an active team
             */

        }, {
            key: 'getTeamHomepageLink',
            value: function getTeamHomepageLink(statsapiTeam) {
                return _get(MlbLinker.prototype.__proto__ || Object.getPrototypeOf(MlbLinker.prototype), 'getTeamHomepageLink', this).call(this, statsapiTeam);
            }

            /**
             * Returns a team slug such as "yankees"
             * @param {string | number} teamId A numeric team ID, as a string or number
             * @return {string} A team slug, or null if this is not a recognized active team.
             */

        }, {
            key: 'getTeamSlugFromTeamId',
            value: function getTeamSlugFromTeamId(teamId) {
                return _get(MlbLinker.prototype.__proto__ || Object.getPrototypeOf(MlbLinker.prototype), 'getTeamSlugFromTeamId', this).call(this, teamId);
            }

            /**
             * Returns a team slug such as "yankees" based on the statsapi team node
             * @param {object} statsapiTeam A statsapi team node, such as returned the Sports Data Teams or Schedule API
             * @return {string} The team slug, or null if the team is not recognized as an active team
             */

        }, {
            key: 'getTeamSlug',
            value: function getTeamSlug(statsapiTeam) {
                return _get(MlbLinker.prototype.__proto__ || Object.getPrototypeOf(MlbLinker.prototype), 'getTeamSlug', this).call(this, statsapiTeam);
            }

            /**
             * Return the fully qualified URL of the site-core static-assets root, e.g.
             * //www.mlbstatic.com/mlb.com/builds/site-core/fe87f5c56891104097b778aa06b60f1a369ec4fd_1494355291.  The returned
             * URL will not have a trailing slash.  Strings starting with '/images', '/fonts', '/bower_components', '/scripts',
             * etc. are expected to be appended to the returned URL.  Usage:
             *
             * var imageUrl = linker.getFqPathToSiteCoreAssets() + '/images/globallyUsedImage.png';
             *
             * Note that this method cannot be used to reference section-specific assets; these URLs have a different
             * structure, and also contain different build versions.  For that, use getFqPathToSectionAssets().
             *
             * @param app Server-side only: the "app" variable available to all MLB BANE controllers. Required.
             * @return {string}
             */

        }, {
            key: 'getFqPathToSiteCoreAssets',
            value: function getFqPathToSiteCoreAssets(app) {
                if (this._clientSide) {
                    return Helpers._getMetaTagContent(this._metaTags, 'siteAssetsUri');
                }
                // We're in a controller, so:
                return this._windowOrReq.res.locals.siteAssetsUri;
            }

            /**
             * Return the fully qualified URL of the current section's static-assets root, e.g.
             * //www.mlbstatic.com/mlb.com/sections/club-schedule/builds/c47203dcaf2560531a98f3471b9972f1b9e6f492_1494356470.
             * The returned URL will not have a trailing slash.  Strings starting with '/images' or any other directories your
             * section exposes in its section_config.json are expected to be appended to the returned URL.  Usage:
             *
             * var imageUrl = linker.getFqPathToSectionAssets() + '/images/sectionSpecificImage.png';
             *
             * Note that this method cannot be used to reference global (site-core) assets; these URLs have a different
             * structure, and also contain different build versions.  For that, use getFqPathToSiteCoreAssets().
             *
             * @return {string}
             */

        }, {
            key: 'getFqPathToSectionAssets',
            value: function getFqPathToSectionAssets() {
                if (this._clientSide) {
                    return Helpers._getMetaTagContent(this._metaTags, 'sectionAssetsUri');
                }
                // We're in a controller, so:
                return this._windowOrReq.res.locals.sectionAssetsUri;
            }

            /**
             * Generate a link to the sortable stats page with a stat type and sort column, and optional team id and optional club view. http://mlb.mlb.com/stats/sortable.jsp#statType=hitting&sortColumn=avg
             * @param statType The tab to be selected on the stats page, e.g. 'hitting'
             * @param sortColumn The initial column to be sorted on when the stats page loads
             * @param siteType 'jsp' or 'v2' - default is 'jsp', pass 'v2' for http://m.mlb.com/stats page
             * @param teamId default is '' for all MLB
             * @param {boolean} keepTeam default is false. This allows the page to be seen in the club's styles. keepTeam in getLegacyLink() doesn't work for the jsp sortable stats page, so it has to be set here instead.
             * @return {string} A link to the sortable stats page.
             */

        }, {
            key: 'getSortableStatsLink',
            value: function getSortableStatsLink() {
                var statType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'hitting';
                var sortColumn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'avg';
                var siteType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'jsp';
                var teamId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
                var keepTeam = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

                var teamParam = '';

                if (siteType === 'jsp') {
                    var sortablePage = this._langCode !== 'en' ? 'sortable_' + this._langCode : 'sortable';
                    if (teamId) {
                        var tricode = this._teamData.getTeamTricodeFromId(teamId);
                        teamParam = '&team_id=' + teamId;
                        if (keepTeam) {
                            return this.getLegacyLink('/stats/' + sortablePage + '.jsp?c_id=' + tricode + '#statType=' + statType + '&sortColumn=' + sortColumn + teamParam, false, siteType);
                        } else {
                            return this.getLegacyLink('/stats/' + sortablePage + '.jsp#statType=' + statType + '&sortColumn=' + sortColumn + teamParam, false, siteType);
                        }
                    } else {
                        return this.getLegacyLink('/stats/' + sortablePage + '.jsp#statType=' + statType + '&sortColumn=' + sortColumn, keepTeam, siteType);
                    }
                } else {
                    var langParam = this._langCode !== 'en' ? '&lang=' + this._langCode : '';
                    if (teamId) {
                        teamParam = '&team_option=' + teamId;
                        return this.getLegacyLink('/stats/?stat_type=' + statType + '&sort_column=' + sortColumn + teamParam + langParam, keepTeam, siteType);
                    } else {
                        return this.getLegacyLink('/stats/?stat_type=' + statType + '&sort_column=' + sortColumn + langParam, false, siteType);
                    }
                }
            }

            /**
             * Generate a link to the mlb stats or milb club stats page with.  https://www.mlb.com/stats/home-runs, https://www.mlb.com/yankees/stats/home-runs
             * We expect two different sets of arguments based on the current context and destructure the
             * arguments and assign them accordingly. We opt to not extend to a separate function for milb
             * in order to preserve functionality across all of the packages that are already relying
             * on this public method.
             * @param {object} statsapiGame MiLB: A SD API game node.
             * @param {string} sId Season id
             * @param {string} statType MLB: The tab to be selected on the stats page, default to 'hitting'
             * @param {string} sortColumn MLB: The initial column to be sorted on when the stats page loads
             * @return {string} A link to the mlb or club stats page.
             */

        }, {
            key: 'getStatsLink',
            value: function getStatsLink() {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                if (this._isMilb) {
                    var statsapiGame = args[0],
                        sId = args[1];

                    var gid = _getGID(statsapiGame, this);
                    var siteId = sId || this._siteId;
                    var host = this._appView === 'web' ? this._milbHostName : this._milbMobileHostName;
                    return host + '/milb/stats/stats.jsp?gid=' + gid + '&t=g_rcp&sid=' + siteId;
                }

                var _args$ = args[0],
                    cfg = _args$ === undefined ? {} : _args$;
                var _cfg$sortColumn = cfg.sortColumn,
                    sortColumn = _cfg$sortColumn === undefined ? '' : _cfg$sortColumn,
                    _cfg$statType = cfg.statType,
                    statType = _cfg$statType === undefined ? '' : _cfg$statType;

                var url = this.getLink('/stats');
                var type = statType && statType === 'pitching' ? '/pitching' : '';
                var column = sortColumn ? '/' + sortColumn : '';

                return '' + url + type + column;
            }

            /**
             * @method getFacebookGameLink
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @return A Facebook Game of the Week URL, or null if none found
             */

        }, {
            key: 'getFacebookGameLink',
            value: function getFacebookGameLink(statsapiGame) {
                return this._getGOWLink(statsapiGame, 'facebook');
            }

            /**
             * @method getYouTubeGameLink
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @return A YouTube Game of the Week URL, or null if none found
             */

        }, {
            key: 'getYouTubeGameLink',
            value: function getYouTubeGameLink(statsapiGame) {
                return this._getGOWLink(statsapiGame, 'youtube');
            }

            /**
             * @method getContactUsLink
             * @return The contact us url
             */

        }, {
            key: 'getContactUsLink',
            value: function getContactUsLink() {
                return this.getLink('/official-information/contact', false);
            }

            /**
             * Return a standings link
             * @param {number} leagueId League id
             * @return {string} url path
             */

        }, {
            key: 'getStandingsLink',
            value: function getStandingsLink(leagueId) {
                return this._milbHostName + '/standings/index.jsp?lid=' + (leagueId || this._leagueId);
            }

            /**
             * Return schedule url maintaining team/league context if applicable
             * @return {string} url path
             */

        }, {
            key: 'getScheduleLink',
            value: function getScheduleLink() {
                return this.getLink('/schedule', true);
            }

            /**
             * Return tunein link
             * @param {object} statsapiGame A SD API game node
             * @return {string} url path
             */

        }, {
            key: 'getTuneInLinkForContextTeam',
            value: function getTuneInLinkForContextTeam(statsapiGame) {
                return _getTuneInLink(statsapiGame, this, 'contextOnly');
            }

            /**
             * Return tune-in link for MiLB
             * @param {object} statsapiGame A SD API game node
             * @param {string} homeOrAway String that denotes whether team is home or away team
             * @return {string} url path
             */

        }, {
            key: 'getTuneInLink',
            value: function getTuneInLink(statsapiGame) {
                var homeOrAway = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'any';

                return _getTuneInLink(statsapiGame, this, homeOrAway);
            }

            /**
             * @method getYouTubeGameLink
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @return A YouTube Game of the Week URL, or null if none found
             */

        }, {
            key: '_getGOWLink',
            value: function _getGOWLink(statsapiGame, type) {

                var gameLink = null;

                if (statsapiGame.content && statsapiGame.content.media && statsapiGame.content.media.epg) {
                    var epgs = statsapiGame.content.media.epg;
                    var epg = void 0;
                    var items = void 0;
                    var item = void 0;

                    for (var eIdx = 0, eLength = epgs.length; eIdx < eLength; eIdx++) {

                        epg = epgs[eIdx];

                        if (epg.title.toLowerCase() === 'mlbtv' && epg.items) {

                            items = epg.items;
                            for (var iIdx = 0, iLength = items.length; iIdx < iLength; iIdx++) {
                                item = items[iIdx];

                                var isYouTubeOn = type === 'youtube' && item.youtube && item.youtube.fgow && item.mediaState === 'MEDIA_ON';
                                var isFacenbookOn = type === 'facebook' && item.facebook && item.facebook.fgow && item.mediaState === 'MEDIA_ON';

                                if (isYouTubeOn) {
                                    gameLink = statsapiGame.youtubeMLBLink || 'https://www.mlb.com/live-stream-games/youtube';
                                    return gameLink;
                                }

                                if (isFacenbookOn) {
                                    var videoId = item.facebook.videoId || '';
                                    var pageId = item.facebook.pageId || '';

                                    if (videoId && pageId) {
                                        gameLink = 'https://www.facebook.com/' + pageId + '/videos/' + videoId;
                                        return gameLink;
                                    }
                                }
                            }
                        }
                    }
                }

                // Provide override url for youtube playback on wbc games
                // Scope to sportId 51, and apply to youtube fgow inspection.
                // Should only apply if above match is not met.
                if (type === 'youtube' && statsapiGame.teams && statsapiGame.teams.home && statsapiGame.teams.home.team && statsapiGame.teams.home.team.sport && statsapiGame.teams.home.team.sport.id === 51) {
                    if (statsapiGame.xrefIds && Array.isArray(statsapiGame.xrefIds)) {
                        statsapiGame.xrefIds.forEach(function (xrefId) {
                            if (xrefId && xrefId.xrefType === 'bam_youtube_free') {
                                gameLink = 'https://youtu.be' + xrefId.xrefId;
                            }
                        });
                    }
                }

                return gameLink;
            }

            /**
             * For legacy links where alternate language is supported, insert language code into url in appropriate place
             * @param url {String}
             * @returns {string} URL with lang code (ie: 'http://m.es.mlb.com/video/?game_pk=509714' when
             * 'http://m.mlb.com/video/?game_pk=509714' is passed in)
             */

        }, {
            key: 'legacyLinkInsertLang',
            value: function legacyLinkInsertLang() {
                var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;


                var retUrl = url;

                if (url) {

                    if (this._langCode !== 'en') {

                        var isV2 = url.indexOf('m.mlb.com') !== -1;

                        if (isV2) {

                            retUrl = retUrl.replace('m.mlb.com', 'm.' + this._langCode + '.mlb.com');
                        } else {
                            // jsp

                            retUrl = retUrl.replace('mlb.com/', 'mlb.com/' + this._langCode + '/');
                        }
                    }
                }

                return retUrl;
            }

            /**
             * Passed the ID of a team (where the team is an active MLB team or a "TBD team" used as a placeholder for an
             * unknown team during postseason), returns the fully qualified URL of the logo to display for this team (a team
             * logo in the case of an active team; an AL or NL logo in the case of most TBD teams; or a generic baseball logo
             * in the case of two special-case TBD teams as well as any input we can't otherwise parse).
             *
             * @param {number|string} teamId The numeric ID of an active team or a postseason "TBD team"
             * @param {Object} options Options (optional) describing logo variation; two properties, both optional, are:
             * `logoType` ("cap" (the default), "primary", or "wordmark"); and `onLight` (true, the default, for the "-light"
             * variant, false for the "-dark" variant).  Note: `logoType` is ignored for league logos and for the generic
             * baseball logo.  Also note: as of 9/11/2017, there is no "-dark" variant of the league logos.  This method allows
             * the user to specify onLight = false ("-dark"), however, because presumably this resource will exist at some
             * point.
             * @return {string} A fully qualified URL to an SVG logo.
             */

        }, {
            key: 'getFqLogoUrlFromTeamId',
            value: function getFqLogoUrlFromTeamId(teamId) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { logoType: 'cap', onLight: true };

                var logoType = options.logoType || 'cap';
                var onLight = typeof options.onLight === 'boolean' ? options.onLight : true;
                var teamIdNum = parseInt(teamId);
                if (isNaN(teamIdNum)) {
                    teamIdNum = 0;
                }

                var isActiveTeam = this.getBamTeamData().isTeamActive(teamIdNum);

                // SCENARIO 1: ACTIVE TEAM:
                if (isActiveTeam) {
                    return this._siteCoreLogosRoot + 'team-' + logoType + '-on-' + (onLight ? 'light' : 'dark') + '/' + teamId + '.svg';
                }

                // SCENARIO 2: ASG TEAM:
                if (teamIdNum === AL_ASG_TEAM_ID || teamIdNum === NL_ASG_TEAM_ID) {
                    return this.getFqLogoUrlFromLeagueId(teamIdNum);
                }

                var leagueInfo = MlbTbdTeamToLeagueMap$1.getLeagueInfoFromTbdTeamId(teamId);
                // SCENARIO 3: TBD TEAM WITH A KNOWN LEAGUE:
                if (!leagueInfo.unknownLeague) {
                    return this.getFqLogoUrlFromLeagueId(leagueInfo.leagueId, onLight);
                }

                // SCENARIO 4: A VALID TBD TEAM WITHOUT A KNOWN LEAGUE, OR WE COULDN'T PARSE TEAMID:
                // (note: we use "cap" regardless of options; this logo only exists in "cap" format):
                return this.getFqGenericBaseballLogo(onLight);
            }

            /**
             * Returns the fully qualified URL to either the AL or NL logos.
             * @param {number|string} leagueId (AL = 103, NL = 104)
             * @param {boolean} onLight True for light-background version, false for dark-background version BUT NOTE: THERE ARE
             * NO DARK-BACKGROUND LEAGUE LOGOS AS OF 9/12/2017); default is true
             * @return {string}
             */

        }, {
            key: 'getFqLogoUrlFromLeagueId',
            value: function getFqLogoUrlFromLeagueId(leagueId) {
                var onLight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                var leagueIdNum = parseInt(leagueId) || 0;
                var leagueIdAsTeam = void 0;
                switch (leagueIdNum) {
                    // Note: no break stmts or braces needed here since in each case we return immediately:
                    case AL_ASG_TEAM_ID:
                    case NL_ASG_TEAM_ID:
                        return this._siteCoreLogosRoot + 'team-cap-on-' + (onLight ? 'light' : 'dark') + '/' + leagueIdNum + '.svg';
                    case AL_ID:
                    case NL_ID:
                        leagueIdAsTeam = leagueIdNum === AL_ID ? AL_ASG_TEAM_ID : NL_ASG_TEAM_ID;
                        return this._siteCoreLogosRoot + 'team-cap-on-' + (onLight ? 'light' : 'dark') + '/' + leagueIdAsTeam + '.svg';
                    default:
                        return this.getFqGenericBaseballLogo(onLight);
                }
            }

            /**
             * Returns the fully qualified URL to either the AL or NL logos (passed an unrecognized leagueAbbrev, returns
             * the generic baseball logo).
             * @param {string} leagueAbbrev 'AL' or 'NL'
             * @param {boolean} onLight True for light-background version, false for dark-background version BUT NOTE: THERE ARE
             * NO DARK-BACKGROUND LEAGUE LOGOS AS OF 9/12/2017); default is true
             * @return {string}
             */

        }, {
            key: 'getFqLogoUrlFromLeagueAbbrev',
            value: function getFqLogoUrlFromLeagueAbbrev(leagueAbbrev) {
                var onLight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                switch (leagueAbbrev) {
                    // Note: no break stmts or braces needed here since in each case we return immediately:
                    case 'AL':case 'NL':
                        return this.getFqLogoUrlFromLeagueId({ AL: AL_ID, NL: NL_ID }[leagueAbbrev], onLight);
                    default:
                        return this.getFqGenericBaseballLogo(onLight);
                }
            }

            /**
             * Returns the fully qualified URL of 000.svg, the generic baseball logo generally used when we don't have a logo
             * for a team for whatever reason.
             * @param {boolean} onLight True for light-background version, false for dark-background version (they are identical
             *      as of 9/12/2017); default is true
             * @return {string}
             */

        }, {
            key: 'getFqGenericBaseballLogo',
            value: function getFqGenericBaseballLogo() {
                var onLight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                return this._siteCoreLogosRoot + 'team-cap-on-' + (onLight ? 'light' : 'dark') + '/' + '000.svg';
            }

            /**
             * Returns the fully qualified URL of 000.svg, the generic baseball logo generally used when we don't have a logo
             * for a team for whatever reason.
             * @param {boolean} onLight True for light-background version, false for dark-background version (they are identical
             *      as of 9/12/2017); default is true
             * @return {string}
             */

        }, {
            key: 'getFqWBCLeagueLogo',
            value: function getFqWBCLeagueLogo() {
                var onLight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                return this._siteCoreLogosRoot + 'team-cap-on-' + (onLight ? 'light' : 'dark') + '/' + '000.svg';
            }

            /**
             * Passed a legacy MLB URL (e.g. to an image) which is http://, not https://, returns the https:// version if
             * it can.  Passed a URL which already starts with https://, returns the URL unchanged.  Passed a relative-to-root
             * url like /images/some/img.jpg, prepends https://securea.mlb.com.
             *
             * Specifics:
             *
             * - Passed an http://mlb.mlb.com URL, returns an https://securea.mlb.com URL
             * - Passed an http://m.mlb.com , returns an https://msecurea.mlb.com URL
             * - Passed e.g. /images/some/img.jpg, returns https://securea.mlb.com/images/some/img.jpg
             *
             * @param {string} url
             * @param {boolean} returnInsecureIfNoMatch If true and no match is found, url will be returned (otherwise null
             *   will be returned).  Optional; default is true.  Note: if the passed URL is relative-to-root (/some/path, with
             *   no hostname or protocol), a secure URL will always be returned; thus this param will have no effect).
             * @returns {string} A fully qualified https:// URL if it can, otherwise null (if returnSecureIfNoMatch is false)
             *   or url (if returnInsecureIfNoMatch is true)
             * @throws Error if URL doesn't start with http:// or https:// or /.
             */

        }], [{
            key: 'getSecureLink',
            value: function getSecureLink(url, returnInsecureIfNoMatch) {
                returnInsecureIfNoMatch = returnInsecureIfNoMatch === undefined ? true : returnInsecureIfNoMatch;
                var hosts = [{ insecure: 'mlb.mlb.com', secure: 'securea.mlb.com' }, { insecure: 'm.mlb.com', secure: 'msecurea.mlb.com' }];
                if (url.indexOf('https://') === 0) {
                    // already secure:
                    return url;
                } else if (url.indexOf('http://') === 0) {
                    // An FQ, non-secure URL:
                    var host = void 0;
                    var replacementCandidate = void 0;
                    for (var _i8 = 0, _ln7 = hosts.length; _i8 < _ln7; _i8++) {
                        host = hosts[_i8];
                        replacementCandidate = 'http://' + host.insecure;
                        if (url.indexOf(replacementCandidate) === 0) {
                            return 'https://' + host.secure + url.substring(replacementCandidate.length);
                        }
                    }
                    // no luck:
                    return returnInsecureIfNoMatch ? url : null;
                } else if (url.indexOf('/') === 0) {
                    return 'https://' + hosts[0].secure + url; // https://securea.mlb.com
                } else {
                    throw new Error('the url "' + url + '" is not fully qualified, nor does it start with "/"; one of these' + 'is required.');
                }
            }

            /**
             * For some legacy URLs, this class returns localized URLs containing e.g. "/es" which we don't want; this static
             * method returns the passed URL without it if it's present.  Also removes "/en" if present (unlikely).
             * @param url
             * @return The passed URL with the language path element removed if present (e.g. https://host/path when passed
             * https://host/es/path).
             */

        }, {
            key: 'stripLanguagePathElement',
            value: function stripLanguagePathElement(url) {
                var retUrl = url;
                var langRegexes = [/\/es\//, /\/en\//];
                for (var _i9 = 0, _ln8 = langRegexes.length; _i9 < _ln8; _i9++) {
                    retUrl = retUrl.replace(langRegexes[_i9], '/');
                }
                return retUrl;
            }
        }]);

        return MlbLinker;
    }(BamLinker$1);

    /**
     * Return the specified ticket link if available, otherwise null
     * @param statsapiGame A SD API game node
     * @param forceDesktop If true, only desktop links will be returned; if false, mobile ones will be returned as well
     * @param linker the MlbLinker instance calling this function
     * @param sellerType Which type of seller's link is okay to return?  Three possible values:
     *          - 'contextOnly': only return link to seller associated with the context team
     *          - 'opponentOnly': only return link to seller asociated with the opponent
     *          - 'any' expected to be called only when there isn't a context (i.e., the league site), returns the home
     *            team's seller's link if it exists; otherwise returns the away team's seller's link
     *
     * @return {string} A URL or null
     * @private
     */


    function _getTicketsLink(statsapiGame, forceDesktop, linker, sellerType, nonGameEvent) {
        if (!nonGameEvent) {
            BamArgValidator$1.validateStatsapiGame(statsapiGame);
            BamArgValidator$1.validateArgs(arguments, ['statsapiGame', 'forceDesktop', 'linker', 'sellerType'], ['object', 'boolean', 'object', 'string'], [true, true, true, true]);
        } else {
            BamArgValidator$1.validateStatsapiNonGameEvent(statsapiGame);
        }
        BamArgValidator$1.validateAllowed(sellerType, ['any', 'contextOnly', 'opponentOnly']);

        if (sellerType !== 'any' && !linker._teamId) {
            throw new Error('You called _getTicketsLink() with sellerType="' + sellerType + '"; this type requires ' + 'a team context, but there is none (because you are not on a club site).');
        }

        if (linker._isMilb && statsapiGame.status && statsapiGame.status.abstractGameCode === 'F') {
            return null; // Return null in milb context for final games
        }

        if (statsapiGame.tickets) {
            var url = null;
            var awayId = !nonGameEvent ? statsapiGame.teams.away.team.id : statsapiGame.teams[0] && statsapiGame.teams[0].id;
            var homeOrAway = +linker._teamId === awayId ? 'away' : 'home';

            if (sellerType === 'any') {
                url = _getTicketsLinkOfType(statsapiGame.tickets, 'home', linker) || _getTicketsLinkOfType(statsapiGame.tickets, 'away', linker);
            } else {
                homeOrAway = sellerType === 'contextOnly' ? awayId === +linker._teamId ? 'away' : 'home' : // Ensure these values are numbers
                awayId !== +linker._teamId ? 'away' : 'home';

                if (linker._isMilb && nonGameEvent) {
                    homeOrAway = 'home';
                }

                url = _getTicketsLinkOfType(statsapiGame.tickets, homeOrAway, linker);
            }

            if (url !== null) {
                return url;
            }
        }

        if (!forceDesktop && linker._deviceType !== 'desktop') {
            // Mobile user; no mobile tix link so try for desktop - if no luck on the second try, we'll return null
            // because we'll get to this if clause but not into it:
            return _getTicketsLink(statsapiGame, true, linker, sellerType);
        }
        return null;
    }

    /**
     * Returns a ticket link based on the specified type (home or away) and other criteria
     * @param ticketsArr Array of
     * @param homeOrAway
     * @param linker an MlbLinker instance
     * @private
     */
    function _getTicketsLinkOfType(ticketsArr, homeOrAway, linker) {
        var ticketType = linker._deviceType === 'mobile' ? 'mobile' : 'wired';
        var ticketEl = void 0;
        for (var _i10 = 0, _ln9 = ticketsArr.length; _i10 < _ln9; _i10++) {
            ticketEl = ticketsArr[_i10];
            if (ticketEl.ticketType && ticketEl.ticketType === ticketType) {
                if (ticketEl.ticketLinks && ticketEl.ticketLinks[homeOrAway]) {
                    return ticketEl.ticketLinks[homeOrAway];
                }
            }
        }
        return null;
    }

    /**
     * Return the specified TuneIn audio link if available, otherwise null
     * @param statsapiGame A SD API game node
     * @param linker the MlbLinker instance calling this function
     * @param homeAwayContext Which team's audio is okay to return?  Three possible values:
     *          - 'contextOnly': only return audio associated with the context team
     *          - 'home': only return audio asociated with the home team
     *          - 'away': only return audio asociated with the away team
     *          - 'any' expected to be called only when there isn't a context (i.e., the league site), returns the home
     *            team's audio link if it exists; otherwise returns the away team's audio link
     *
     * @return {string} A URL or null
     * @private
     */
    function _getTuneInLink(statsapiGame, linker, homeAwayContext) {
        BamArgValidator$1.validateStatsapiGame(statsapiGame);
        BamArgValidator$1.validateArgs(arguments, ['statsapiGame', 'linker', 'homeAwayContext'], ['object', 'object', 'string'], [true, true, true, true]);
        BamArgValidator$1.validateAllowed(homeAwayContext, ['contextOnly', 'home', 'away', 'any']);

        var url = null;
        if (statsapiGame.broadcasts) {
            var showHome = homeAwayContext === 'home';
            var showAway = homeAwayContext === 'away';

            if (homeAwayContext === 'contextOnly') {
                var awayId = statsapiGame.teams.away.team.id;
                showHome = linker._teamId !== awayId;
                showAway = linker._teamId === awayId;
            }
            if (homeAwayContext === 'any') {
                showHome = true;
                showAway = true;
            }

            var b = void 0;
            for (b = 0; b < statsapiGame.broadcasts.length; ++b) {
                var broadcast = statsapiGame.broadcasts[b] || {};
                if (broadcast.type === 'INET') {

                    if (showHome && broadcast.homeAway === 'home') {
                        return broadcast.sourceUrl || linker.getLink('live-stream-games/audio', false);
                    }
                    if (showAway && broadcast.homeAway === 'away') {
                        return broadcast.sourceUrl || linker.getLink('live-stream-games/audio', false);
                    }
                }
            }
        }
        return url;
    }

    /**
     * Set milb specific properties on linker object.
     * @param {object} linker The instance of the MlbLinker that you would like to modify
     * @param {object} windowOrReq Either window or request object
     * @param {object} options Linker options
     */
    function _setMilbProperties(linker, windowOrReq) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


        var metaLeagueId = void 0;
        var metaTeamId = void 0;
        var metaSlug = void 0;
        var metaAppView = void 0;
        var metaLocale = void 0;
        linker._isMilb = true;

        if (linker._clientSide) {
            metaAppView = Helpers._getMetaTagContent(linker._metaTags, 'app-view');
            metaLocale = Helpers._getMetaTagContent(linker._metaTags, 'locale');
            metaLeagueId = Helpers._getMetaTagContent(linker._metaTags, 'league-id');
            metaTeamId = Helpers._getMetaTagContent(linker._metaTags, 'team-id');
            metaSlug = Helpers._getMetaTagContent(linker._metaTags, 'club');
        } else if (windowOrReq && windowOrReq.locals) {
            var _ref2 = windowOrReq.locals.globalData || {},
                _team2 = _ref2.team,
                league = _ref2.league;

            var _ref3 = windowOrReq.locals.responseConfig || {},
                appViews = _ref3.appViews,
                locale = _ref3.locale,
                club = _ref3.club;

            linker._deviceType = options.deviceType || 'desktop';
            metaTeamId = _team2 && _team2.data && _team2.data.team.id;
            metaLeagueId = league && league.data && league.data.league.id;
            metaAppView = appViews || '';
            metaLocale = locale || 'en';
            metaSlug = !club ? '' : club;
        }

        var siteId = void 0;

        if (metaTeamId) {
            siteId = 't' + metaTeamId;
        } else if (metaLeagueId) {
            siteId = 'l' + metaLeagueId;
        } else {
            siteId = null;
        }

        if (options.langCodeOverride) {
            options.locale = options.langCodeOverride;
        }

        if (options.teamSlugs || windowOrReq.teamSlugs) {
            options.teamSlugs = options.teamSlugs || windowOrReq.teamSlugs || null;
        }

        linker._baseUrl = options.baseUrl;
        linker._milbHostName = linker._baseUrl || 'http://www.milb.com';
        linker._milbMobileHostName = linker._baseUrl || 'http://m.milb.com';
        linker._siteId = options.siteId || siteId;
        linker._teamId = +options.teamId || +metaTeamId; // set teamId as integer
        linker._slug = options.slug || metaSlug || '';
        linker._leagueId = options.leagueId || metaLeagueId;
        linker._appView = options.appView || metaAppView;
        linker._langCode = options.locale || metaLocale;

        linker._ymdDate = options.ymdDate || null;
        linker._calEventId = options.calEventId || null;
        linker._gameId = options.gameId || null;
        linker._videoId = options.videoId || null;
        linker._teamSlugs = options.teamSlugs || null;
        linker._sportCodeMap = {
            11: 'aaa',
            12: 'aax',
            13: 'afa',
            14: 'afx',
            15: 'asx',
            16: 'rok',
            17: 'win'
        };
    }

    /**
     * Helper function to build gameId in MiLB context if supplied the statsApiGame and the linker
     * @param {object} statsapiGame A SD API game node
     * @param {object} linker MlbLinker instance calling this function
     * @return {string} Returns GID string
     */
    function _getGID(statsapiGame, linker) {
        var awayTeamCode = statsapiGame.teams.away.team.teamCode;
        var homeTeamCode = statsapiGame.teams.home.team.teamCode;
        var awaySportCode = linker._sportCodeMap[statsapiGame.teams.away.team.sport.id];
        var homeSportCode = linker._sportCodeMap[statsapiGame.teams.home.team.sport.id];
        var gameNumber = statsapiGame.gameNumber;
        var gameDate = statsapiGame.gameDate.substr(0, 10);
        gameDate = gameDate.replace(/-/g, '_');

        return gameDate + '_' + awayTeamCode + awaySportCode + '_' + homeTeamCode + homeSportCode + '_' + gameNumber;
    }

    module.exports = MlbLinker;

    /***/
}]
/******/);
});